import React from "react";
import tickmark from "../assets/images/tickCheckbox.png"
import { capitalizeFirstLetter } from "../util";

const Gender = {
  Male: "male",
  Female: "female",
  Unspecified: "unspecified",
  All: "all"
}

const Subjects = {
  Maths: "Maths",
  PE: "PE",
  Reading: "Reading",
  Science: "Science",
  Writing: "Writing",
  MathId: "MA",
  PEId: "PE",
  ReadingId: "RE",
  ScienceId: "SC",
  WritingId: "WR",
  MATH: "MATH",
  READ: "READ",
  SCI: "SCI",
  WRITE: "WRITE",
  Empty: "",
  MathsInReading: "Maths ∩ Reading",
  MathsInWriting: "Maths ∩ Writing",
  ReadingInWriting: "Reading ∩ Writing",
  MathsInWritingInReading: "Maths ∩ Writing ∩ Reading",
  mathsOrReading: "mathsOrReading",
  readingOrWriting: "readingOrWriting",
  reading: "reading",
  maths: "maths",
  writing: "writing",
  mathOrWritingCount: "mathOrWritingCount",
  mathOrWritingOrReading: "mathOrWritingOrReading",
}

const Roles = {
  Admin: "Admin",
  LeadTeacher: "LeadTeacher",
  MappixAdmin: "Mappix Admin",
  Teacher: "Teacher",
  SchoolAdmin: "School Admin",
  SeniorLeader: "Senior Leader",
  SuperAdmin: "SuperAdmin"
}

const Accessors = {
  Action: "action",
  Addresss: "address",
  Active: "active",
  Classes: "classes",
  Classname: "className",
  Classsize: "classSize",
  City: "city",
  ContactName: "Contact Name",
  Country: "country",
  CreatedAt: "createdAt",
  Dob: "dob",
  Eal: "eal",
  EHCP: "ehcp",
  Email: "email",
  Ethnicity: "ethnicity",
  Eyfs: "eyfs",
  FirstName: "firstName",
  Gender: "gender",
  Gld: "gld",
  KsResults: "ksResults",
  IsRegistrationGroup: "isRegistrationGroup",
  Ks1Results: "ks1Results",
  LastName: "lastName",
  Name: "name",
  OtherNeeds: "otherNeeds",
  Passing: "passing",
  PostalCode: "postCode",
  PP: "pp",
  Report: "Report",
  Send: "send",
  SenStatus: "senStatus",
  SchoolYear: "schoolYear",
  Subjects: "Subjects",
  Type: "type",
  Upn: "upn",
  UserCount: "userCount",
  UpdatedAt: "Updated At",
  View: "view",
  Year: "year",
};

const Array = {
  AllSubjects: ["All Subjects", Subjects.Maths, Subjects.Reading, Subjects.Writing, Subjects.Science, Subjects.PE],
  AndMyRoleIs: "And my role is:",
  BigPicture: ["Curriculum Coverage", "Predicted Pass Rates", "End of Year Predictions", "Demographics", "Progress", "Subject Strength Analysis"],
  classNames: ["Curiculum", "PassRate", "Predictions", "Demographics", "Progress", "StrengthAnalysis"],
  Genders: ["M", "All", "F"],
  IAmAPartOf: "I am a part of:",
  SendStatuses: ["All  Pupils (incl. SEND)", "All SEND", "SEND Support only", "EHCP only", "Not SEND"],
  Subjects: [Subjects.Maths, Subjects.Reading, Subjects.Writing, Subjects.Science, Subjects.PE],
  TellUsBitMoreAboutYou: "Tell us bit more about you",
  Years: ["All", 1, 2, 3, 4, 5, 6],
  YesNoOrAll: ["N", "All", "Y"],
}

const AssessmentDisabledTexts = {
  AddEvidence: "Add Evidence",
  Below: " Below",
  DisabledOutcome: "Please complete marking to calculate outcome",
  Expected: " Expected Standard",
  EnterNewName: "Enter a new Name :",
  EvidenceCannotBeDeleted: "You can not delete Evidence after submitting the Assessment",
  EvidenceCannotBeEdit: "You can not Edit Evidence Name after submitting the Assessment",
  GreaterDepth: " Greater Depth",
  None: "none",
  NoEvidenceFound: "No evidence found.",
  Scroll: "Scroll",
  UploadNew: "Upload New",
  WorkingTowards: " Working Towards",
}

const BigPicture = {
  Subjects: Array.AllSubjects,
  Classes: ["All Classes", "Red1", "Orange2"],
  Years: Array.Years,
  SendStatus: Array.SendStatuses,
  GenderSpecification: Array.Genders,
  EalSpecifications: Array.YesNoOrAll,
  PpSpecifications: Array.YesNoOrAll,

  ProgressInputKeys: {
    Exceeding: "exceeding",
    NotOnTrack: "notOnTrack",
    Ontrack: "onTrack",
    Unknown: "unknown"
  },

  ProgressOutputKeys: {
    Exceeding: "Exceeding",
    NotOnTrack: "Not On Track",
    Ontrack: "On Track",
    Unknown: "Unknown",
    KeyInsights: "KEY INSIGHTS",
    KeyInsightsAllPupils: "KEY INSIGHTS: ALLPUPILS",
  },

  ProgressMainTableInputKeys: [Subjects.mathOrWritingOrReading, Subjects.Reading.toLowerCase(), Subjects.Writing.toLowerCase(), Subjects.Maths.toLowerCase(), `${Subjects.Reading.toLowerCase()}Fail`, `${Subjects.Writing.toLowerCase()}Fail`, "mathFail", "fail"],
  ProgressMainTableOutputKeys: ["Predicted to pass RWM", "Pass predicted: Reading", "Pass predicted: Writing", "Pass predicted: Maths", "Not predicted to pass:", "Not predicted: Reading", "Not predicted: Writing", "Not predicted: Maths", "Not predicted: ANY"],
  ProgressTableOutputKeys: ["Exceeding", "On Track", "Not On Track", "Unknown"],
  VennDiagramlabels: [Subjects.Reading, Subjects.Writing, Subjects.Maths, `${Subjects.Reading}, ${Subjects.Writing} & ${Subjects.Maths}`, "R&W", "R&M", "M&W"],

}

const BigPictureDashBoardPieChartInput = {
  PupilPremium: "pupilPremium",
  NotPupilPremium: "notPupilPremium",
  Eyfs: "eyfs",
  Eyfs_: "EYFS",
  NotEyfs: "noteyfs",
  NotEyfs_: "notEYFS",
  Send: "sendSupport",
  Send_: "send",
  Ehcp: "ehcp",
  Ehcp_: "EHCP",
  NotSend: "notSend",
  PP: "PP",
  Pp: "pp",
  NotPP: "notPP",
  Lea: "leaCare",
  Fsm: "fsm",
  Fsm6: "fsm6",
  Male: "male",
  Female: "female",
  Unspecified: "unspecified",
  Notspecified: "notSpecified",
  Eal: "EAL",
  NotEal: "notEAL",
  KsHigh: "ksHigh",
  KsMiddle: "ksMiddle",
  KsLow: "ksLow",
  KsBelow: "ksBelow",
  KsUnknown: "ksUnknown",
  KsExs: "ksEXS",
  KsHnm: "ksHNM",
  Year1: "year1",
  Year2: "year2",
  Year3: "year3",
  Year4: "year4",
  Year5: "year5",
  Year6: "year6",

  // PieChart Headings
  AllPupil: "allPupil",
  AllPupilPre: "allPupilPremium",
  Gender: "gender",
  Eal_: "eal",
  SendStatus: "sendStatus",
  Gld: "gld",
  Ks1Maths: "ks1Maths",
  Ks1Reading: "ks1Reading",
  Ks1Writing: "ks1Writing",
  Ks1Science: "ks1Science",
  FreeSchoolMeals: "freeSchoolMeals",
  FreeSchoolMeals6: "freeSchoolMeals6",
  PpStatus: "ppStatus",
  AllSend: "allSend",
  AllSend_: "AllSend",
  AllKs1MathsPupil: "allKs1MathsPupil",
  AllKs1SciencePupil: "allKs1SciencePupil",
  AllKs1WritingPupil: "allKs1WritingPupil",
  AllKs1ReadingPupil: "allKs1ReadingPupil",
  NotGld: "notGld",
  MathsKs1High: "mathsKs1High",
  MathsKs1Middle: "mathsKs1Middle",
  MathsKs1Low: "mathsKs1Low",
  MathsKs1Below: "mathsKs1Below",
  MathsKs1Unknown: "mathsKs1Unknown",
  ReadingKs1High: "readingKs1High",
  ReadingKs1Middle: "readingKs1Middle",
  ReadingKs1Low: "readingKs1Low",
  ReadingKs1Below: "readingKs1Below",
  ReadingKs1Unknown: "readingKs1Unknown",
  WritingKs1High: "writingKs1High",
  WritingKs1Middle: "writingKs1Middle",
  WritingKs1Low: "writingKs1Low",
  WritingKs1Below: "writingKs1Below",
  WritingKs1Unknown: "writingKs1Unknown",
  ScienceKs1High: "scienceKs1High",
  ScienceKs1Middle: "scienceKs1Middle",
  ScienceKs1Low: "scienceKs1Low",
  ScienceKs1Below: "scienceKs1Below",
  ScienceKs1Unknown: "scienceKs1Unknown"
}

const BigPictureDashBoardPieChartLegend = {
  PupilPremium: "Pupil Premium",
  NotPupilPremium: "Not Pupil Premium",
  Eyfs: "EYFS GLD",
  NotEyfs: "EYFS Not GLD",
  Send: "SEND Support",
  Send_: "SEND",
  Ehcp: "EHCP",
  NotSend: "Not SEND",
  Lea: "LEA Care",
  Fsm: "FSM",
  Fsm6: "FSM Ever 6",
  Male: "Male",
  Female: "Female",
  Unspecified: "Unspecified",
  Eal: "EAL",
  NotEal: "Not EAL",
  KsHigh: "KS1 High",
  KsMiddle: "KS1 Middle",
  KsLow: "KS1 Low",
  KsBelow: "KS1 Below",
  KsUnknown: "KS1 Unknown",
  KsExs: "KS1 EXS",
  KsHnm: "KS1 HNM",
  Year1: "Year 1",
  Year2: "Year 2",
  Year3: "Year 3",
  Year4: "Year 4",
  Year5: "Year 5",
  Year6: "Year 6",

  // PieChart Headings
  AllPupil: "All Pupils",
  AllPupilPre: "All Pupil Premium",
  Gender: "Gender",
  Eal_: "EAL Status",
  SendStatus: "SEND Status",
  Gld: "GLD Outcome",
  Ks1Maths: "KS1 Maths",
  Ks1Reading: "KS1 Reading",
  Ks1Writing: "KS1 Writing",
  Ks1Science: "KS1 Science",
  FreeSchoolMeals: "Free School Meals",
  FreeSchoolMeals6: " Free School Meals Ever 6, excl. current FSM",
  PpStatus: "PP Status",
  AllSend: "All Send",
  AllKs1MathsPupil: "All KS1 Maths Pupil",
  AllKs1ReadingPupil: "All KS1 Reading Pupil",
  AllKs1WritingPupil: "All KS1 Writing Pupil",
  AllKs1SciencePupil: "All KS1 Science Pupil",
  NotGld: "Not GLD",
  MathsKs1High: "Maths KS1 High",
  MathsKs1Middle: "Maths KS1 Middle",
  MathsKs1Low: "Maths KS1 Low",
  MathsKs1Below: "Maths KS1 Below",
  MathsKs1Unknown: "Maths KS1 Unknown",
  ReadingKs1High: "Reading KS1 High",
  ReadingKs1Middle: "Reading KS1 Middle",
  ReadingKs1Low: "Reading KS1 Low",
  ReadingKs1Below: "Reading KS1 Below",
  ReadingKs1Unknown: "Reading KS1 Unknown",
  WritingKs1High: "Writing KS1 High",
  WritingKs1Middle: "Writing KS1 Middle",
  WritingKs1Low: "Writing KS1 Low",
  WritingKs1Below: "Writing KS1 Below",
  WritingKs1Unknown: "Writing KS1 Unknown",
  ScienceKs1High: "Science KS1 High",
  ScienceKs1Middle: "Science KS1 Middle",
  ScienceKs1Low: "Science KS1 Low",
  ScienceKs1Below: "Science KS1 Below",
  ScienceKs1Unknown: "Science KS1 Unknown",
  PreviousYearMaths: "Previous Year Maths",
  PreviousYearReading: "Previous Year Reading",
  PreviousYearWriting: "Previous Year Writing",
  PreviousYearScience: "Previous Year Science",
}

const BPComparison = {
  Comparison: "Comparison",
  Gender: "GENDER",
  Ethnicity: "ETHNICITY",
  None: "None",
  PP: "PP",
  EAL: "EAL",
  EHCP: "EHCP",
  FSM: "FSM",
  SEND: "SEND",
  GLD: "GLD/KS1",
  PUPIL_PREMIUM: "PUPIL PREMIUM",
  MALE: Gender.Male.toUpperCase(),
  FEMALE: Gender.Female.toUpperCase(),
  SERVICECHILDREN: "SERVICE CHILDREN",
  LEA: "LEA",
  UNSPECIFIED_GENDER: Gender.Unspecified.toUpperCase(),
  ALL: Gender.All.toUpperCase(),
  Passed: "Passed",
  SUBJECTNAME: "subjectName",
  pupilYear: "pupilYear",
  Year: "YEAR",
}

const Colors = {
  Secondary: "rgba(56,56,56,0.05)",
  White: "#FFFFFF",
}

const currentYear = new Date().getFullYear();

const Common = {
  Accept: "Accept",
  AcessFromWonde: "Request access from Wonde",
  AcessPendingWonde: "Pending approval from Wonde",
  Actions: "Actions",
  Active: "Active",
  Actual: "Actual",
  AddClass: "Add Class",
  AddComment: "Add/Edit Comment",
  AddGeneralComments: "Add General Comments",
  AddStudents: "AddStudents",
  Address: "Address",
  AddRole: "Add Role",
  All: "All",
  AllClasses: "All Classes",
  AllGroups: "All Groups",
  AllObjectives: "All Objectives",
  AllPupils: "All Pupils",
  AllSend: "All Send",
  AlreadyHaveAnAccount: "Already have an account?",
  AlreadyRegisteredLogin: "AlreadyRegistered?Login",
  AppliedFilters: "Applied Filters",
  AssessmentWriting: "Assess Writing",
  AssignClass: "Assign Class",
  AssignRole: "Assign Role",
  AttitudeToLearning: "Attitude To Learning",

  Back: "Back",
  BackToDashboard: "Back to Dashboard",
  BackToKeyInsight: "BACK TO KEY INSIGHTS",
  BackToLogin: "Back to Login",
  BaseLine: "Baseline",
  BeamCopyright: `© ${currentYear} Topiq Ltd`,
  BeamEducationLink: "beam-education.co.uk",
  BigPicturePageName: "Big Picture / ",
  BLW: "BLW",

  Cancel: "Cancel",
  CannotBeLessThan3Character: "Cannot be less than 3 characters",
  CannotBeLessThan5Character: "Cannot be less than 5 characters",
  CannotBeLessThan8Character: "Cannot be less than 8 characters",
  CategoryName: "categoryName",
  Characteristics: "Characteristics",
  ChangeTargets: "Change targets",
  ChildLookedAfter: "Child: Looked After",
  City: "City",
  Cla: "CLA",
  Class: "Class",
  ClassAverage: "Class Average",
  Classes: "Classes",
  ClassHome: "ClassHome",
  Classname: "className",
  ClassName: "Class Name",
  ClassSize: "Class Size",
  Clear: "CLEAR",
  ClicktoLogin: "Click here to Login",
  ClicktoAdd: "Click here to add files",
  Close: "Close",
  ComingSoon: "This comparison will be coming soon. Stay tuned...",
  Comment: "Comment",
  CommentAllPupils: "Comment All Pupils",
  Comparison: "Comparison",
  CompletePupilDetails: "Complete Pupil Details",
  ContactName: "Contact Name",
  Confirm: "Confirm",
  ConfirmNewPassword: "Confirm New Password",
  Confirmnewpassword: "confirmNewPassword",
  Confirmpassword: "Confirm Password",
  Country: "Country",
  CreateAnAccount: "Create an account",
  CreatedAt: "Created At",
  CurrentPassword: "Current Password",
  Currentpassword: "currentPassword",
  Current: "Current",
  CurrentEvidence: "Current Evidence",
  CurrentOutcome: "Current Outcome",
  CurriculumCoverage: "Curriculum Coverage",
  ClearAll: "CLEAR ALL",

  DateSent: "Date Sent",
  Decline: "Decline",
  Delete: "Delete",
  DeleteClass: "DeleteClass",
  Deleteclass: "Delete Class",
  DeletePupil: "Delete Pupil",
  Demographics: "Demographics",
  DemographicsSubText: "Pupil population sorted by groups.",
  Descending: "descending",
  DisableSchool: "Disable School",
  DisableUser: "Disable User",
  Divider: " / ",
  Dob: "DOB",
  DownloadPDF: "Download PDF",
  DownloadTemplate: "Download Template",
  DragFiles: "Drag files here or click to add",

  Eal: "EAL",
  EalOnly: "EAL Pupils Only",
  Edit: "Edit",
  EditComment: "Edit Comment",
  EditIcon: "Edit Icon",
  EditPupil: "Edit Pupil",
  EditReport: "Edit Report",
  EditTargets: "Edit Targets",
  EditUser: "Edit user",
  EditSchool: "Edit School",
  EHCP: "Education, Health and Care Plan",
  Ehcp: "EHCP",
  EKey: "eKey",
  Email_: "email",
  Email: "Email",
  EmailExample: "Email@address.co.uk",
  EnableSchool: "Enable School",
  EnableUser: "Enable User",
  EndOfYearPredictions: "End of Year Predictions",
  EndOfYearPredictionsSubtext: "Predicted outcomes based on learning trend.",
  EnglishAsAnAdditionalLanguage: "English as an additional language",
  EnterEmail: "Enter Email",
  EnterValidOTPtoLogin: "Enter Valid OTP to Login",
  EnterCurrentPassword: "Enter your Current Password",
  EnterNewPassword: "Enter New password",
  EnterOldPassword: "Enter Old password",
  EnterConfirmpassword: "Re-enter New Password",
  Ethnicity: "Ethnicity",
  EvidenceUploaded: "Evidence Uploaded",
  Exceeding: "Exceeding",
  Expected: "Expected Standard",
  ExpGDS: "Expected Or Greater Depth",
  EXS: "EXS",

  False: "False",
  Filters: "Filters",
  FirstName: "First Name",
  ForeName: "Forename",
  Forename: "foreName",
  ForgotYourPassword: "Forgot your password?",
  FreeSchoolMeals: "Free School Meals",
  FreeSchoolMealsEver6: "Free School Meals Ever 6",
  FSM: "FSM",
  FSM6: "FSM6",

  GDS: "GDS",
  GreaterDepth: "Greater Depth",
  Gender: "Gender",
  GoToClass: "Go Back to classes",
  GLD: "GLD",
  GLDStatus: "GLD Status",
  GLDOutCome: "GLD OutCome",
  GenerateReport: "Generate Report",
  GoToLogin: "Go To Login",
  
  Hashtag: "",
  HelpIcon: " Help",
  Highest: "Highest",

  ImportFromWonde: "Import From Wonde",
  Invite: "Invites",
  InvitationNotCancel: "Invitation not cancelled",
  InviteUser: "Resend Invite",
  InviteUser_: "Invite User",
  InvalidEmailFormat: "Invalid Email Format",
  IsRegistration: "Is Registration Group",

  KsResult: "KSResult",
  KsResult_: "ksResult",
  KsResult1: "Key Stage 1 Result",
  KS1: "KS1",
  KS1M: "KS1M",
  Ks1Result: "KS1Results",
  KS1Result: "KS1 Result",
  KPIObjectives: "KPI Objectives",

  LastName: "Last Name",
  LastYear: "Last year",
  LengthRestriction10: "Can't exceed more than 10 characters",
  LengthRestriction12: "Can't exceed more than 12 characters",
  LengthRestriction: "Can't exceed more than 25 characters",
  LengthRestriction50: "Can't exceed more than 50 characters",
  LengthRestriction250: "Can't exceed more than 250 characters",
  Loading: "loading...",
  Login: "Login",
  LogOut: "Log Out",
  Lowest: "Lowest",

  ManualUpload:"Manual Upload",
  Main: "main",
  MARK: "MARK",
  Marking: "Marking",
  Move: "Move",
  Movefrom: "moveFrom",
  MoveFrom: "Move From",
  MovePupil: "Move Pupil",
  MustBeDigits: "Must be only digits",
  MyCheck: "myCheck",
  MyClasses: "My Classes",

  No: "No",
  N: "N",
  NA: "N.A.",
  Name: "Name",
  NamesCannotContainNumbersOrSpecialCharacters: "Names Cannot Contain Numbers Or Special Characters",
  Newpassword: "newPassword",
  NewPassword: "New password",
  NewtoMappix: "New to Mappix? Click Here!!",
  Next: "Next",
  NoClassesFound: "No Classes Found",
  NoClassesAvailable: "No Other Class available for perticular year",
  NoClassIsAssigned: "No Class is Assigned to you",
  None: "None",
  NoDataFound: "No Report Found",
  NoPupilFound: "No Pupil's Data Found",
  NoPupil: "No Pupil in class",
  NoPupils: "No Pupil's",
  NotDeleted: "Not Deleted!",
  NotEal: "Not EAL",
  Notes: "Notes",
  NotPp: "Not PP",
  NotOnTrack: "Not On Track",
  NoSchoolFound: "No School Found",
  NotSend: "Not SEND",
  NoUserFound: "No User Found",

  Objectives: "Objectives",
  OK: "OK",
  oldPassword: "Old Password",
  OnTrack: "On Track?",
  OnTrack_: "OnTrack",
  Otp: "OTP",
  ObjectivesMarked: "Objectives Marked",
  ObjectivesMarkedInComparison: "Objectives marked in comparison to academic calendar.",
  OnlyNumbersAllowed: "Only Numbers Allowed",
  Overall: "Overall",

  Page: "Page",
  Passing: "Passing",
  Password_: "password",
  Password: "Password",
  Passwordsmustmatch: "Passwords must match",
  PasswordsMustContain: "Password must contain at least 1 lowercase, 1 uppercase, 1 number, and 1 special character",
  PerformaceProgress: "Performace Progress",
  Phone: "Phone",
  PhoneNumberMustBeTenDigits: "Phone number must be at least 10 digits",
  PhoneNumberIsRequired: "Phone number is required",
  PlaceValue: "Place Value",
  PleaseCheckTermsAndConditions: "Please check the terms and condition",
  PleaseEnterOTP: "Please Enter OTP.",
  PleaseEnterOTPSentToYourMail: "Please Enter Otp sent to your mail.",
  PleaseEnterYourEmailAddress: "Please enter your email address, otp will be sent to your mail id.",
  PleaseEnterYourEmailAddressAndPassword: "Please enter your email address & password.",
  Pleaseenteryouremailaddresstoregister: "Please enter your email address to register.",
  PleaseCreateYourUniqueUserLogin: "Please create your unique user login.",
  PleaseSelect: "Please Select",
  PleaseSelectSubject: "Please select Subject!",
  PleaseSelectPupil: "Please select Pupils!",
  PleaseSelectClassToMove: "Please Select Class To Move Pupil",
  PleaseUploadFiles: "Please Upload Files!",
  PostalAddress: "Address",
  PostalCode: "Postal Code",
  PostalCodeRegexpMessage: "Doesn\"t match the standard UK format",
  PP: "PP",
  PpOnly: "PP Pupils Only",
  Predicted: "Predicted",
  PredictedPassRate: "Predicted Pass Rate",
  PredictedPassRateTitle: "Predicted Pass Rates ",
  PredictedPassRateSubTitle: "Percentage of pupils predicted to achieve the Expected Standard or higher.Click for names.",
  PredictedPassRateSubTitleSecondary: "Pupils predicted to achieve the Expected Standard or higher.",
  Prediction: "Prediction",
  PreviousYear: "Previous Year",
  PreviousYear_: "previousYear",
  PreviousYearResult: "Previous Year Result",
  Progress: "Progress",
  ProgressMeter: "Progress Meter",
  ProgressOverTime: "Progress Over Time",
  ProgressThisYear: "Progress This Year",
  Pupils: "Pupils",
  Publish: "Publish",
  pupilProgress: "Pupil Progress",
  pupilProgressAgainstBaseLine: "Pupil progress against selected baseline",

  Ranking: "Ranking",
  Rename: "Rename",
  Register: "Register",
  Registration: "Registration.",
  Registrationgroup: "RegistrationGroup",
  RegistrationGroup: "Registration Group",
  Remove: "remove",
  RemoveClass: "Remove Class",
  RemovePupil: "Remove Pupil",
  RemoveRole: "Remove Role",
  RenameClass: "RenameClass",
  Report: "Report",
  Required: "Required",
  RequestAccessFromWonde: "Request access from Wonde",
  Result: "Result",
  Revoke: "Revoke",
  Role: "Role",
  Roles: "Roles",
  RowsPerPage: "Rows per page :",

  Save: "Save",
  SaveComment: "Save Comment",
  SavedReports: "Saved Reports",
  SEND: "SEND",
  SC: "SC",
  SchoolID: "School ID",
  SchoolEmail: "Email",
  SchoolName: "School Name",
  SchoolUsers: "Users",
  SchoolYear: "School Year",
  Scroll: "Scroll",
  SearchByNameOrUPN: "Search by Name/UPN",
  SelectAllStudents: "Select all students",
  SelectOneOrMoreSubjects: "Select one or more subjects that are linked to the files you are uploading.",
  SelectStudents: "Select the students for the evidence provided.",
  Send: "Send",
  Send_: "SEND",
  SendOtp: "Send OTP",
  SenStatus: "SEND Status",
  SenSupport: "SEND Support",
  ServiceChild: "Service Child",
  SetPassword: "Set Password",
  Showing: "Showing",
  SignIn: "Sign In",
  SignOut: "Sign Out",
  Staffwithmarkingpermissions: "Staff with marking permissions:",
  SubjectActual: "SubjectActual",
  SubjectAreaProgress: "Subject Area Progress",
  SubjectAreaStrengths: "Subject Area Strengths",
  SubjectName: "subjectName",
  Subjects: "Subjects",
  SubjectPerformanceSummary: "Subject Performance Summary",
  Submit: "Submit",
  SubmitRequest: "Submit Request",
  Summaryinfo: "Summary information about performance in every subject.",
  SurName: "Surname",
  Surname: "surName",

  SuperAdmin: {
    AddSchool: "Add School",
    EditSchool: "Edit School Details",
    SendInvite: "Send Invite to User",
    BillingAddress: "Billing Address",
    ContactDetails: "Contact Details",
    NumberOfUsers: "Number of Users",
    SchoolDetails: "School Details",
    SchoolName: "School Name",
    SchoolWebsiteUrl: "School Website URL (Optional)",
    UseAddressEnteredAbove: "Use Address entered above",
    VatNumber: "Vat Number",
    LicenseNumber: "License Number",
    B2C: "Is B2C"

  },

  Targets: "Targets",
  TargetLevel: "Target Level",
  TeacherComment: "Teacher Comment",
  Teachers: "Teachers",
  TeachingGroup: "Teaching Group",
  TeachingGroup_: "TeachingGroup",
  TeachersAssessments: "Teachers Assessments",
  To: "To",
  Trend: "Trend",
  Trends: "Trends",
  True: "True",
  TrulyInformativeAssessment: "Truly informative assessment",

  UnableToUpdateSchool: "Unable to Update Schools",
  UnableToCreateAdmin: "Unable to Create Admin, Invite Not Sent",
  UnableToPerformAction: "Unable to Perform Action right now. Try Again!",
  Unkown: "Unkown",
  Update: "Update",
  UpdateAcademicDetails: "Update Academic Details",
  UpdatedAt: "Updated At",
  Updatedat: "updatedAt",
  UpdateInvite: "Update Invite",
  UpdateMyDetails: "Update my details",
  UpdateProfile: "Update Profile",
  UpdatePupils: "Update pupils",
  UpdateReport: "Update Report",
  Upload: "Upload",
  UploadPupils: "Upload pupils",
  UploadEvidenceforClass: "Upload Evidence for Class",
  Upn: "UPN",
  UserInvited: "User Invited",

  View: "View",
  ViewProgress: " View Progress",
  ViewCurrentProgress : "Current Progress",
  ViewReport: " View Report",
  ViewSchool: "View School",
  VennDiagramSubject: {
    Math: Subjects.Maths,
    Reading: Subjects.Reading,
    Writing: Subjects.Writing,
    MathAndReading: `${Subjects.Maths} And ${Subjects.Reading}`,
    MathAndWriting: `${Subjects.Maths} And ${Subjects.Writing}`,
    ReadingAndWriting: `${Subjects.Reading} And ${Subjects.Writing}`,
    MathReadAndWrite: `${Subjects.Maths}, ${Subjects.Reading} And ${Subjects.Writing}`,
    None: "None"
  },

  Welcome: "Welcome.",
  WondeSchoolID: "Wonde school ID",
  WorkingBelow: "Working Below",
  WritingAssessment: "Writing Assessment",
  WTS: "WTS",
  WorkingTowards: "Working Towards",
  X: "X",
  Yes_: "Yes",
  Year: "Year",
  YearEndPrediction: "Year end Prediction",
  YearGroups: "year groups",
  Yes: "Y",
  YesDelete: "Yes, Delete",
  You: "You",
  YourDetails: "Your Details",
  YourRole: "Your Role",

}

const CurriculumCoverageAccordion = {
  YearGroup: "YEAR GROUP comparison",
  ClassGroup: "CLASS comparison",
  MathsColourHigh: "var(--maths-accordian-high-color)",
  MathsColourLow: "var(--maths-accordian-low-color)",
  ReadingColourHigh: "var(--reading-accordian-high-color)",
  ReadingColourLow: "var(--reading-accordian-low-color)",
  WritingColourHigh: "var(--writing-accordian-high-color)",
  WritingColourLow: "var(--writing-accordian-low-color)",
  ScienceColourHigh: "var(--science-accordian-high-color)",
  ScienceColourLow: "var(--science-accordian-low-color)",
  PEColourHigh: "var(--pe-accordian-high-color)",
  PEColourLow: "var(--pe-accordian-low-color)",
}

const DataType = {
  Password: "password",
  Text: "text",
}

const DefaultData = {
  FilterComponent: { "EAL": false, "allEAL": true, "allPP": true, "classId": "All", "ehcp": true, "female": false, "male": false, "notEAL": false, "notPP": false, "notSen": true, "PP": false, "pupilYear": [1, 2, 3, 4, 5, 6], "sendSupport": true, "subjectName": "All", "unspecified": true }
}

const EditProfileConstants = {
  AreYouSureYouWantToLogout: "Are you sure you want to logout?",
  ChangePassword: "Change Password",
  ConfirmNewPassword: "Confirm New Password",
  ConfirmPassword: "Confirm Password",
  DoYouHaveExternalFunding: "Do you have external funding?",
  ExistingPassword: "Existing Password",
  FirstName: "First Name",
  FullName: "Full Name",
  Hello: "Hello",
  IAmThe: "I am the",
  IamTheCEOFounderOf: "I'm the <b>Founder</b> of <br />",
  IWorkAt: "I work at",
  LastName: "Last Name",
  LogOut: "Log Out",
  LogoutConfirmation: "Logout Confirmation",
  NewPassword: "New Password",
  PhoneNumber: "Phone Number",
  ProvideBackUpEmail: "If we need to help you recover your account, provide a backup email:",
  TellUsABitAboutYourSelf: "Tell us a bit about yourself:",
  UpdatePassword: "Submit",
  UpdateProfile: "Update Profile",
  WhatWouldYouLikeToBeCalled: "What would you like to be called?",
  WhereAreYouBased: "Where are you based?",
  WhereIsYourBusinessLocated: "Where is your business located",
  YesLogout: "Yes, Logout",
  YouCanFindUsAt: "You can find us at",
  YourContactDetails: "Your contact details",
}

const Activity = {
  Activity: "Activity rating",
  ActivityDescription: "Your Mappix activity rating compared to other school users.",

}

const ExternalLinks = {
  BeamEduWebsite: "https://www.beam-education.co.uk/"
}

const KSResults = ["A", "D", "BLW", "PK4", "PK3", "PK2", "PK1", "EM", "WTS", "EXS", "GDS", "U"]

const KSResultsCommonOptions = ["Absent/ Dissaplied/ Unknown", "Below/ Pre key Stage Foundations/ Engagement Model", "Working Towards", "Expected Standard", "Greater Depth"];

const KSResultsScienceOptions = ["Absent/ Dissaplied/ Unknown", "Has Not Met", "Expected Standard"];

const KSResultsScience = ["A", "D", "HNM", "EXS", "U"]

const LocalStorageKeys = {
  StaySignedInUser: "StaySignedInUser",
  StaySignedInSocialUser: "StaySignedInSocialUser"
}

const MappixLevels = {
  FiveBelow: "5B",
  FiveWorkingTowards: "5W",
  FiveExpected: "5E",
  FiveGreaterThanExpected: "5G",
  FourBelow: "4B",
  FourWorkingTowards: "4W",
  FourExpected: "4E",
  FourGreaterThanExpected: "4G",
  OneBelow: "1B",
  OneWorkingTowards: "1W",
  OneExpected: "1E",
  OneGreaterThanExpected: "1G",
  SixBelow: "6B",
  SixWorkingTowards: "6W",
  SixExpected: "6E",
  SixGreaterThanExpected: "6G",
  ThreeBelow: "3B",
  ThreeWorkingTowards: "3W",
  ThreeExpected: "3E",
  ThreeGreaterThanExpected: "3G",
  TwoBelow: "2B",
  TwoWorkingTowards: "2W",
  TwoExpected: "2E",
  TwoGreaterThanExpected: "2G",
}

const Marking = {
  Actual: "Actual",
  AddEvidence: "Add Evidence",
  AdditionSubtractionMultiplicationDivision: "Addition, subtraction, multiplication & division",
  Attainment: "Attainment",
  ClassId: "classId",
  DateAdded: "Date Added",
  Dd: "dd",
  Eal: Common.Eal,
  Evidence: "Evidence",
  Ff: "ff",
  Fractions: "Fractions",
  Geometry: "Geometry",
  HidePriorMarking: "Hide Prior Marking",
  MappixCalculatedOutcome: "Mappix Calculated Outcome",
  Marking: "Marking",
  Marksheet: "Marksheet",
  Measures: "Measures",
  NoDataFound: "No data found!",
  PeoplePremium: "PP",
  PlaceValue: "Place Value",
  Predicted: "Predicted",
  ServiceChild: "S",
  ShowPriorMarking: "Show Prior Marking",
  SubjectClassId: "subjectClassId",
  TeacherAssessmentOutcome: "Teacher Assessment Outcome",
  CheckBox: [
    { className: "checkmark check-below", image: tickmark, spanClass: "comment-below" },
    { className: "checkmark check-emerging", image: tickmark, spanClass: "comment-emerging" },
    { className: "checkmark check-expected", image: tickmark, spanClass: "comment-expected" },
    { className: "checkmark check-greater", image: tickmark, spanClass: "comment-greater" },
    { className: "checkmarkAb check-absent", image: tickmark, spanClass: "comment-absent" },
  ],
  Grade: {
    B: "Working Below",
    W: "Working Towards",
    E: "Expected Standard",
    G: "Greater Depth"
  }
}

const MarkingColors = {
  Absent: "var(--absent-colour)",
  Absentborder: "#5656567A",
  Below: "var(--below-colour)",
  Emerging: "var(--emerging-colour)",
  Expected: "var(--expected-colour)",
  GreaterDepth: "var(--greater-colour)",
  White: "var(---white-color)",
}

const MarkingOutcome = {
  G_Secure: "Greater Depth Secure",
  G_GoodFit: "Greater Depth Good Fit",
  E_Secure: "Expected Standard Secure",
  E_GoodFit: "Expected Standard Good Fit",
  E_Just: "Expected Standard Just",
  W_Secure: "Working Towards Secure",
  W_GoodFit: "Working Towards Good Fit",
  W_Just: "Working Towards Good Just",
  Below: "Working Below"
}

const LandingPage = {
  BigPicture: "Big Picture",
  AnalyseData: "Analyse your school data"
}
const MarkingLevels = {
  Abs: "A",
  Absent: "ABSENT",
  Bel: "B",
  Below: "BELOW",
  Eme: "W",
  Emerging: "EMERGING",
  Exp: "E",
  Expected: "EXPECTED",
  GrD: "G",
  GreaterDepth: "GREATER DEPTH",
  WorkingTowards: "WORKING TOWARDS",
  Clear: "0",
  Extended: {
    BLW: "BLW",
    WTS: "WTS",
    EXS: "EXS",
    GDS: "GDS",
  }
}

const NavigationBar = {
  AccountSettings: "Account Settings",
  Admin: Roles.Admin,
  Assessment: "Assess Wri...",
  BigPicture: "Big Picture",
  ClassHome: "Class Home",
  Dashboard: "Dashboard",
  Marking: "Marking",
  Maths: Subjects.Maths,
  MyClasses: "My Classes",
  Overview: "Overview",
  PE: Subjects.PE,
  Pupils: Common.Pupils,
  Reading: Subjects.Reading,
  Resouces: "Resouces",
  Science: Subjects.Science,
  SuperAdmin: Roles.SuperAdmin,
  Writing: Subjects.Writing,
}

const PupilProgressOptions = ["Greater", "Expected", "WorkingTowards", "SubjectActual"]

const previousYearOutcome = ["WTS", "EXS", "GDS"];

const previousYearOutcomeSubjects = {
  PYOMaths: "PYO: Maths",
  PYOReading: "PYO: Reading",
  PYOWriting: "PYO: Writing",
  PYOScience: "PYO: Science",
}

const Ratings = {
  Icons: {
    Apple: "M5.32995 2.57041C5.24565 3.97943 5.45229 5.39071 5.937 6.71642C6.42172 8.04212 7.17413 9.25387 8.1474 10.2762C6.25591 10.8185 4.56247 11.8981 3.27253 13.384C1.98259 14.8699 1.1516 16.6983 0.880392 18.6472C0.226394 23.3241 1.18586 28.0843 3.60056 32.1427L4.29549 33.3142L4.38087 33.4393L7.19236 37.2237C7.78786 38.0258 8.55102 38.6884 9.4287 39.1655C10.3064 39.6426 11.2775 39.9226 12.2745 39.9861C13.2714 40.0496 14.2702 39.895 15.2013 39.5332C16.1325 39.1713 16.9735 38.6109 17.666 37.8908C17.7469 37.8066 17.8441 37.7397 17.9515 37.6939C18.059 37.6481 18.1746 37.6246 18.2914 37.6246C18.4082 37.6246 18.5238 37.6481 18.6313 37.6939C18.7388 37.7397 18.8359 37.8066 18.9169 37.8908C19.6093 38.6109 20.4504 39.1713 21.3815 39.5332C22.3126 39.895 23.3114 40.0496 24.3084 39.9861C25.3053 39.9226 26.2765 39.6426 27.1541 39.1655C28.0318 38.6884 28.795 38.0258 29.3905 37.2237L32.202 33.4373L32.2854 33.3122L32.9823 32.1408C35.3982 28.0842 36.3597 23.3255 35.7084 18.6492C35.5162 17.2712 35.0432 15.9474 34.3186 14.7597C33.5941 13.572 32.6335 12.5456 31.4962 11.7442C30.359 10.9427 29.0694 10.3832 27.7072 10.1003C26.345 9.81742 24.9392 9.81714 23.5769 10.0995L19.8024 10.8818H19.7965C19.856 9.33309 20.0982 7.66525 20.5728 6.23965C21.1486 4.51622 21.9468 3.47977 22.8363 3.11047C23.2009 2.95828 23.4902 2.66747 23.6405 2.302C23.7907 1.93653 23.7896 1.52634 23.6374 1.16168C23.4853 0.797013 23.1944 0.507739 22.829 0.357492C22.4635 0.207246 22.0533 0.208335 21.6887 0.360521C19.5999 1.23216 18.4125 3.29909 17.7474 5.29653L17.6561 5.57847C17.1676 4.63333 16.5361 3.76936 15.7837 3.01715C14.7541 1.98615 13.5171 1.1857 12.1547 0.668827C10.7924 0.151956 9.33575 -0.0695406 7.88134 0.0190112C7.2176 0.0572155 6.59098 0.3377 6.12032 0.807259C5.64966 1.27682 5.36771 1.90279 5.32796 2.56643M11.1376 18.0833C10.4486 18.2203 9.81722 18.7047 9.4221 19.628C9.01904 20.5692 8.87609 21.965 9.31091 23.7063C9.4003 24.0871 9.33625 24.4878 9.1326 24.8218C8.92896 25.1558 8.60206 25.3962 8.22258 25.4912C7.84309 25.5861 7.44149 25.5279 7.10456 25.3292C6.76763 25.1304 6.52244 24.8071 6.42198 24.429C5.86603 22.2013 5.97127 20.1204 6.68407 18.4546C7.40481 16.7728 8.75894 15.52 10.5539 15.1626C10.7484 15.1167 10.9502 15.1104 11.1472 15.1441C11.3442 15.1778 11.5324 15.2508 11.7006 15.3588C11.8687 15.4668 12.0135 15.6075 12.1261 15.7727C12.2387 15.9378 12.317 16.1239 12.3562 16.3198C12.3954 16.5158 12.3947 16.7177 12.3543 16.9134C12.3138 17.1092 12.2343 17.2947 12.1206 17.4591C12.0069 17.6235 11.8613 17.7633 11.6924 17.8702C11.5235 17.9771 11.3348 18.0508 11.1376 18.0833Z",
    Bear: "M20.6038 12.207C20.4545 12.207 20.3084 12.2504 20.1834 12.332C20.0583 12.4137 19.9598 12.5299 19.8998 12.6666C19.8183 12.8526 19.9151 13.0571 20.0596 13.2L20.8282 13.9686C20.8996 14.0402 20.9844 14.097 21.0778 14.1357C21.1712 14.1745 21.2713 14.1944 21.3724 14.1944C21.4735 14.1944 21.5736 14.1745 21.6669 14.1357C21.7603 14.097 21.8451 14.0402 21.9165 13.9686L22.6851 13.2C22.828 13.0571 22.9264 12.8526 22.845 12.6666C22.7849 12.5299 22.6864 12.4137 22.5614 12.332C22.4363 12.2504 22.2902 12.207 22.1409 12.207H20.6038Z M10.6124 3.86038C10.6124 4.68276 10.8707 5.44519 11.3103 6.07081C9.94686 7.86313 9.07529 10.0305 9.07529 12.4408C9.07529 15.8471 10.4603 18.1252 12.6984 19.5501L2.30874 25.5481C1.27442 26.1442 0.511579 27.1182 0.180684 28.2653C-0.150211 29.4123 -0.0233757 30.643 0.534512 31.6985C1.0924 32.7539 2.03786 33.5519 3.17203 33.9245C4.30621 34.2971 5.5407 34.2154 6.61585 33.6965C6.2561 34.5581 6.12687 35.4984 6.24088 36.425C6.35489 37.3517 6.70821 38.2326 7.26606 38.9813L8.64182 40.8305C9.14282 41.5042 9.79454 42.0512 10.5448 42.428C11.2951 42.8047 12.1232 43.0006 12.9628 43C13.8023 42.9994 14.6301 42.8023 15.3799 42.4245C16.1296 42.0467 16.7806 41.4987 17.2806 40.8243C18.5952 41.287 19.9789 41.5225 21.3725 41.5206C22.8128 41.5206 24.1947 41.2747 25.4783 40.8182C25.9778 41.4935 26.6285 42.0425 27.3783 42.4212C28.128 42.7999 28.9561 42.9978 29.7961 42.999C30.6361 43.0002 31.4647 42.8047 32.2156 42.4281C32.9665 42.0515 33.6187 41.5044 34.1201 40.8305L35.4974 38.9813C36.0564 38.231 36.41 37.3479 36.5233 36.4192C36.6365 35.4905 36.5054 34.5483 36.143 33.6858C37.2072 34.222 38.4377 34.3254 39.5765 33.9743C40.7152 33.6233 41.6739 32.845 42.2515 31.8027C42.8291 30.7604 42.9808 29.535 42.6748 28.3833C42.3688 27.2316 41.6288 26.2431 40.61 25.6249L30.3372 19.3564C32.4031 17.9253 33.6698 15.698 33.6698 12.4408C33.6698 10.0305 32.7982 7.86313 31.4347 6.07081C32.0201 5.24807 32.2582 4.22799 32.0974 3.23112C31.9367 2.23425 31.3901 1.34071 30.5757 0.743685C29.7614 0.146663 28.7448 -0.105858 27.7457 0.0407205C26.7467 0.187299 25.8455 0.7212 25.2369 1.52698C23.9365 1.04585 22.613 0.786073 21.3725 0.786073C20.132 0.786073 18.8085 1.04585 17.5081 1.52698C17.0201 0.888724 16.3443 0.419475 15.5758 0.185217C14.8073 -0.0490408 13.9846 -0.0365251 13.2236 0.221005C12.4625 0.478535 11.8013 0.968126 11.3329 1.62093C10.8646 2.27374 10.6126 3.05693 10.6124 3.86038ZM14.4553 1.55465C15.064 1.55465 15.6174 1.79137 16.0294 2.17566C14.6748 2.86461 13.4396 3.76662 12.371 4.84723C12.2045 4.49576 12.1297 4.10789 12.1534 3.71971C12.1771 3.33154 12.2986 2.95567 12.5066 2.62708C12.7147 2.29849 13.0024 2.02786 13.3431 1.84035C13.6838 1.65285 14.0664 1.55456 14.4553 1.55465ZM29.0583 30.8251C28.1874 31.198 27.431 31.7952 26.8663 32.556L25.489 34.4052C24.7557 35.3873 24.3813 36.5913 24.4284 37.8161C23.4907 38.2219 22.4578 38.4463 21.3725 38.4463C20.2934 38.4463 19.2666 38.225 18.3351 37.8238C18.3839 36.5964 18.0094 35.3894 17.2745 34.4052L15.8972 32.556C15.3285 31.7898 14.5653 31.1896 13.6868 30.8174V30.7606C13.6868 28.7222 14.4965 26.7673 15.9379 25.3259C17.3792 23.8845 19.3341 23.0748 21.3725 23.0748C23.4109 23.0748 25.3658 23.8845 26.8072 25.3259C28.2485 26.7673 29.0583 28.7222 29.0583 30.7606V30.8251ZM30.5954 3.86038C30.5954 4.21393 30.5155 4.54903 30.3741 4.84723C29.3055 3.76662 28.0703 2.86461 26.7157 2.17566C27.044 1.86891 27.4548 1.66478 27.8976 1.58837C28.3404 1.51197 28.7959 1.56661 29.2081 1.74558C29.6203 1.92456 29.9711 2.22007 30.2176 2.59578C30.4641 2.97149 30.5954 3.41104 30.5954 3.86038ZM17.5296 10.67C17.3258 10.67 17.1303 10.589 16.9862 10.4449C16.842 10.3007 16.7611 10.1052 16.7611 9.90139C16.7611 9.69755 16.842 9.50206 16.9862 9.35793C17.1303 9.21379 17.3258 9.13282 17.5296 9.13282C17.7335 9.13282 17.929 9.21379 18.0731 9.35793C18.2172 9.50206 18.2982 9.69755 18.2982 9.90139C18.2982 10.1052 18.2172 10.3007 18.0731 10.4449C17.929 10.589 17.7335 10.67 17.5296 10.67ZM21.3725 19.1243C18.4012 19.1243 15.9925 16.6341 15.9925 14.5129C15.9925 12.3916 18.4012 10.67 21.3725 10.67C24.3438 10.67 26.7526 12.3916 26.7526 14.5129C26.7526 16.6341 24.3438 19.1243 21.3725 19.1243ZM25.984 9.90139C25.984 10.1052 25.903 10.3007 25.7589 10.4449C25.6147 10.589 25.4192 10.67 25.2154 10.67C25.0116 10.67 24.8161 10.589 24.6719 10.4449C24.5278 10.3007 24.4468 10.1052 24.4468 9.90139C24.4468 9.69755 24.5278 9.50206 24.6719 9.35793C24.8161 9.21379 25.0116 9.13282 25.2154 9.13282C25.4192 9.13282 25.6147 9.21379 25.7589 9.35793C25.903 9.50206 25.984 9.69755 25.984 9.90139ZM14.0926 33.9578L15.4699 35.8086C15.711 36.1325 15.8859 36.5007 15.9848 36.8922C16.0836 37.2837 16.1043 37.6908 16.0458 38.0904C15.9873 38.4899 15.8506 38.874 15.6437 39.2207C15.4367 39.5674 15.1635 39.8699 14.8396 40.1111C14.5157 40.3522 14.1475 40.5272 13.756 40.626C13.3645 40.7248 12.9574 40.7456 12.5578 40.687C12.1583 40.6285 11.7742 40.4919 11.4275 40.2849C11.0808 40.0779 10.7783 39.8047 10.5371 39.4808L9.15984 37.6301C8.67307 36.976 8.46609 36.1553 8.58442 35.3486C8.70276 34.5418 9.13672 33.8152 9.79084 33.3284C10.445 32.8416 11.2657 32.6346 12.0724 32.753C12.8791 32.8713 13.6058 33.3037 14.0926 33.9578ZM28.6709 33.9594C28.9122 33.6356 29.2148 33.3625 29.5616 33.1557C29.9083 32.9488 30.2924 32.8123 30.692 32.754C31.0915 32.6956 31.4986 32.7165 31.8901 32.8154C32.2815 32.9144 32.6496 33.0895 32.9734 33.3307C33.2972 33.5719 33.5703 33.8745 33.7771 34.2213C33.984 34.5681 34.1205 34.9522 34.1788 35.3517C34.2372 35.7513 34.2163 36.1584 34.1174 36.5498C34.0184 36.9413 33.8433 37.3094 33.6021 37.6332L32.2264 39.4824C31.9852 39.8063 31.6827 40.0795 31.336 40.2864C30.9893 40.4934 30.6052 40.63 30.2056 40.6886C29.8061 40.7471 29.399 40.7263 29.0075 40.6275C28.616 40.5287 28.2478 40.3537 27.9239 40.1126C27.6 39.8715 27.3268 39.5689 27.1198 39.2222C26.9128 38.8755 26.7762 38.4914 26.7177 38.0919C26.6592 37.6924 26.6799 37.2852 26.7787 36.8937C26.8775 36.5022 27.0525 36.134 27.2936 35.8101L28.6709 33.9594Z",
    Bolt: "M11.5442 0.535994C11.7168 0.206478 12.0581 0 12.4301 0H29.1175C29.952 0 30.4194 0.961693 29.9039 1.61782L20.6211 13.4322C20.1056 14.0883 20.573 15.05 21.4075 15.05H33.191C34.0628 15.05 34.5171 16.0877 33.9258 16.7283L12.3989 40.0491C11.6921 40.8148 10.4318 40.1241 10.697 39.1163L14.7199 23.8295C14.8867 23.1954 14.4085 22.575 13.7528 22.575H1.65269C0.901046 22.575 0.418091 21.7768 0.766861 21.111L11.5442 0.535994Z",
    Dog: "M23.0402 17.2015C23.6117 17.2015 24.179 17.2995 24.7174 17.4913L34.0523 20.8153C36.0445 21.5247 37.375 23.4108 37.375 25.5255V41.5667C37.375 41.9469 37.2235 42.3114 36.954 42.5802C36.6844 42.849 36.3187 43 35.9375 43H30.1875C29.8063 43 29.4406 42.849 29.171 42.5802C28.9014 42.3114 28.75 41.9469 28.75 41.5667V36.534C28.75 33.7726 26.5114 31.534 23.75 31.534H19.375C16.6136 31.534 14.375 33.7726 14.375 36.534V41.5667C14.375 41.9469 14.2235 42.3114 13.954 42.5802C13.6844 42.849 13.3187 43 12.9375 43H7.1875C6.80625 43 6.44062 42.849 6.17103 42.5802C5.90145 42.3114 5.75 41.9469 5.75 41.5667V25.9341C5.75 23.8184 4.3043 22.0274 2.75035 20.5916C1.06122 19.0309 0 16.8107 0 14.335C0 13.5748 0.302901 12.8457 0.842068 12.3081C1.38123 11.7705 2.1125 11.4685 2.875 11.4685C3.6375 11.4685 4.36876 11.7705 4.90793 12.3081C5.4471 12.8457 5.75 13.5748 5.75 14.335C5.75142 15.0948 6.05478 15.8231 6.59364 16.3604C7.1325 16.8977 7.86294 17.2001 8.625 17.2015H23.0402ZM46 7.1688V10.0353C46 11.5558 45.3942 13.014 44.3159 14.0891C43.2375 15.1643 41.775 15.7683 40.25 15.7683H38.6934C37.9652 15.7683 37.375 16.3585 37.375 17.0866C37.375 17.9978 36.4728 18.6342 35.6144 18.3286L29.1979 16.044C27.2055 15.3346 25.875 13.4485 25.875 11.3336V1.43581C25.875 0.159322 27.4221 -0.480265 28.3286 0.422681L29.3157 1.40788C30.2531 2.34355 31.5234 2.86906 32.8479 2.86906H35.5979C36.5781 2.86906 37.7317 3.57851 38.1692 4.45369C38.5636 5.23949 39.3675 5.73555 40.2467 5.73555H44.5625C44.9437 5.73555 45.3094 5.88655 45.579 6.15534C45.8485 6.42413 46 6.78868 46 7.1688ZM35.9375 7.1688C35.9375 6.88533 35.8532 6.60823 35.6952 6.37253C35.5373 6.13683 35.3128 5.95313 35.0501 5.84465C34.7874 5.73617 34.4984 5.70779 34.2196 5.76309C33.9407 5.81839 33.6846 5.9549 33.4835 6.15534C33.2825 6.35578 33.1456 6.61116 33.0901 6.88919C33.0347 7.16721 33.0631 7.45539 33.1719 7.71728C33.2807 7.97917 33.465 8.20301 33.7014 8.3605C33.9378 8.51799 34.2157 8.60205 34.5 8.60205C34.8812 8.60205 35.2469 8.45105 35.5165 8.18226C35.786 7.91347 35.9375 7.54892 35.9375 7.1688Z",
    Horse: "M21.5164 15.3564H32.3281C32.8257 15.3564 33.311 15.404 33.7809 15.4961V11.5231C33.7809 9.4038 35.4979 7.68376 37.6157 7.68376H39.388C39.689 7.68376 39.9347 7.43803 39.9347 7.13703V5.35094C39.9347 4.93936 40.268 4.6061 40.678 4.6061C41.9619 4.6061 43.0016 5.64734 43.0016 6.93123V9.98585C43.0016 12.1052 41.2846 13.8252 39.1668 13.8252H37.3961C37.3243 13.8252 37.2532 13.8394 37.1869 13.8669C37.1205 13.8943 37.0603 13.9346 37.0095 13.9854C36.9587 14.0361 36.9185 14.0964 36.891 14.1627C36.8635 14.2291 36.8494 14.3002 36.8494 14.372V16.8614C37.7896 17.5651 38.5527 18.4785 39.0779 19.529C39.6031 20.5794 39.876 21.7379 39.8748 22.9123V33.939C39.8748 34.8343 39.5705 35.7029 39.0117 36.4024L34.0451 42.6191C33.9504 42.738 33.8301 42.834 33.6931 42.8999C33.5562 42.9659 33.4062 43.0001 33.2542 43H31.3852C31.319 43.0001 31.2541 42.9817 31.1978 42.947C31.1415 42.9123 31.0959 42.8625 31.0663 42.8034C31.0366 42.7442 31.024 42.678 31.0299 42.6121C31.0358 42.5462 31.0599 42.4832 31.0995 42.4302L34.5381 37.8399C35.1246 37.0578 35.3764 36.0748 35.2382 35.1071C35.0999 34.1394 34.5829 33.2662 33.8009 32.6797L29.9431 29.7817C29.4214 29.3898 28.7865 29.178 28.134 29.1782H15.8418C14.8037 29.1794 13.7766 28.9672 12.824 28.5547C12.7504 28.5232 12.669 28.5145 12.5904 28.5298C12.5118 28.5452 12.4396 28.5838 12.3833 28.6407L11.0318 29.9921C10.9353 30.0886 10.8592 30.2035 10.808 30.33C10.7568 30.4565 10.7316 30.5919 10.7339 30.7284C10.7362 30.8648 10.7659 30.9994 10.8213 31.1241C10.8767 31.2488 10.9567 31.361 11.0564 31.4542L12.9945 33.4107C13.235 33.6507 13.5608 33.7855 13.9006 33.7855H14.6024C15.0079 33.7855 15.3365 34.1157 15.3365 34.5211V36.1229C15.3365 36.2194 15.3175 36.315 15.2805 36.4042C15.2435 36.4933 15.1893 36.5743 15.121 36.6425C15.0526 36.7107 14.9715 36.7647 14.8823 36.8015C14.793 36.8383 14.6974 36.8572 14.6009 36.857H13.9006C13.3292 36.8586 12.7632 36.7468 12.2355 36.528C11.7077 36.3092 11.2286 35.9877 10.826 35.5823L8.91398 33.6534C8.1285 32.878 7.68089 31.8238 7.66848 30.7201C7.66601 30.1817 7.77049 29.6481 7.97586 29.1504C8.18123 28.6526 8.4834 28.2006 8.86483 27.8206L9.84925 26.8331C9.91881 26.7631 9.96021 26.67 9.96559 26.5714C9.97097 26.4729 9.93995 26.3758 9.87843 26.2987C9.0266 25.2283 8.47908 23.9482 8.29353 22.5929L6.58884 10.2377C6.57938 10.169 6.55438 10.1034 6.51575 10.0459C6.47712 9.9883 6.42588 9.94029 6.36592 9.9055C6.30595 9.87071 6.23885 9.85004 6.1697 9.84507C6.10056 9.8401 6.03119 9.85096 5.96686 9.87681L3.7738 10.7614L1.81879 7.24453L4.24221 4.61839H3.00285C2.94859 4.61812 2.89503 4.60617 2.8458 4.58335C2.79657 4.56053 2.75283 4.52737 2.71757 4.48613C2.6823 4.44489 2.65634 4.39653 2.64143 4.34436C2.62653 4.29218 2.62304 4.23741 2.6312 4.18377C2.73514 3.44911 3.10072 2.77664 3.66077 2.28995C4.22082 1.80326 4.9377 1.53504 5.67968 1.53459H6.78542V0.413487C6.78563 0.339276 6.80575 0.26648 6.84369 0.202697C6.88162 0.138913 6.93598 0.0864793 7.00109 0.050866C7.06619 0.0152527 7.13967 -0.00223475 7.21384 0.000228535C7.28801 0.00269182 7.36016 0.0250156 7.42276 0.0648702L9.37931 1.52998H17.4067C17.7676 1.52998 18.0609 1.82331 18.0609 2.18575C18.0609 3.20396 17.5311 4.09623 16.7325 4.60456H20.8299C21.1985 4.60456 21.498 4.90557 21.498 5.27415C21.499 6.05431 21.3065 6.82255 20.9377 7.51003C20.5689 8.19751 20.0353 8.78277 19.3848 9.21337H23.3501C23.7002 9.21337 23.9828 9.49748 23.9828 9.84764C23.9839 10.9673 23.6798 12.0661 23.1031 13.0259C22.5265 13.9857 21.6992 14.7702 20.7101 15.295C20.9743 15.3349 21.243 15.3564 21.5164 15.3564ZM6.91135 6.99113C7.11501 6.99113 7.31032 6.91023 7.45432 6.76622C7.59833 6.62222 7.67923 6.42691 7.67923 6.22325V5.37398C7.68387 5.27035 7.66746 5.16686 7.631 5.06975C7.59454 4.97264 7.53879 4.88392 7.4671 4.80895C7.39541 4.73398 7.30927 4.67431 7.21389 4.63355C7.11851 4.59278 7.01585 4.57177 6.91212 4.57177C6.80839 4.57177 6.70574 4.59278 6.61035 4.63355C6.51497 4.67431 6.42883 4.73398 6.35714 4.80895C6.28545 4.88392 6.2297 4.97264 6.19324 5.06975C6.15678 5.16686 6.14037 5.27035 6.14501 5.37398V6.22479C6.14501 6.42844 6.22591 6.62375 6.36992 6.76776C6.51392 6.91176 6.70923 6.99266 6.91289 6.99266 M1.27059 7.83789L0.436672 8.74399C0.259915 8.93517 0.131119 9.16562 0.0608949 9.41634C-0.00932882 9.66706 -0.0189694 9.93088 0.0327682 10.1861C0.247774 11.2411 1.29209 11.7648 2.29033 11.3609L3.05667 11.0522L1.27059 7.83789ZM6.59198 21.4984H5.6091C5.0725 21.4986 4.54121 21.6046 4.04556 21.8101C3.5499 22.0157 3.09961 22.3169 2.72039 22.6966C2.34118 23.0762 2.04047 23.5268 1.83545 24.0227C1.63044 24.5186 1.52512 25.05 1.52552 25.5866V29.211C1.52552 30.3736 1.97857 31.467 2.8002 32.2887L3.40222 32.8907C3.45642 32.945 3.52082 32.9881 3.59171 33.0175C3.66259 33.0469 3.73859 33.0621 3.81534 33.0621C3.89208 33.0621 3.96808 33.0469 4.03896 33.0175C4.10985 32.9881 4.17424 32.945 4.22845 32.8907L5.56917 31.5454C5.67852 31.4357 5.73992 31.2871 5.73992 31.1322C5.73992 30.9774 5.67852 30.8288 5.56917 30.7191L4.96715 30.1171C4.72757 29.8764 4.59288 29.5507 4.59243 29.211V25.5866C4.59243 25.0245 5.04855 24.57 5.6091 24.57H7.19707C6.99712 23.9963 6.85462 23.4041 6.77167 22.8023L6.59198 21.4984ZM26.0715 30.7145V32.519C26.0714 32.7119 26.0332 32.903 25.9592 33.0811C25.8851 33.2593 25.7766 33.421 25.64 33.5572L24.2854 34.9056C23.8778 35.312 23.5547 35.7951 23.3349 36.327C23.1151 36.8589 23.0028 37.4292 23.0046 38.0047V39.4437C23.0046 39.711 23.2196 39.929 23.4884 39.929H25.5877C25.7162 39.9286 25.8392 39.8773 25.9299 39.7864C26.0206 39.6954 26.0715 39.5722 26.0715 39.4437V38.0047C26.0715 37.6561 26.2097 37.3229 26.4554 37.0771L31.0166 32.5098L29.0202 31.0109C28.7647 30.8186 28.4537 30.7146 28.134 30.7145H26.0715Z",
    Icecream: "M32.9989 15.0816V14.8277C32.9989 10.8951 31.4186 7.12366 28.6058 4.34293C25.793 1.5622 21.9779 0 18 0C14.0221 0 10.207 1.5622 7.39421 4.34293C4.58138 7.12366 3.00115 10.8951 3.00115 14.8277V15.0816C2.00006 15.4311 1.15624 16.1194 0.618893 17.0246C0.0815438 17.9298 -0.114721 18.9937 0.0648037 20.0282C0.244328 21.0626 0.788078 22.001 1.59991 22.6774C2.41173 23.3538 3.43934 23.7246 4.50104 23.7243H5.11786L15.3958 41.5064C15.6582 41.9601 16.0373 42.3373 16.4946 42.5996C16.952 42.8619 17.4713 43 18 43C18.5287 43 19.048 42.8619 19.5054 42.5996C19.9627 42.3373 20.3418 41.9601 20.6042 41.5064L30.8821 23.7243H31.499C32.5607 23.7246 33.5883 23.3538 34.4001 22.6774C35.2119 22.001 35.7557 21.0626 35.9352 20.0282C36.1147 18.9937 35.9185 17.9298 35.3811 17.0246C34.8438 16.1194 33.9999 15.4311 32.9989 15.0816ZM21.5416 33.9072L15.6564 23.7243H19.273L23.3508 30.7786L21.5416 33.9072ZM8.57135 23.7243H12.2011L19.8149 36.895L18 40.0347L8.57135 23.7243ZM25.0701 27.7908L22.7265 23.7243H27.4287L25.0701 27.7908Z",
    Lantern: "M27.95 0C28.5202 0 29.0671 0.226517 29.4703 0.62972C29.8735 1.03292 30.1 1.57978 30.1 2.15V4.3L30.53 4.31075C32.6595 4.41736 34.6735 5.31121 36.1811 6.81888C37.6888 8.32654 38.5826 10.3405 38.6893 12.47L38.7 12.9V32.25C38.7002 34.0975 38.1054 35.8959 37.0037 37.379C35.9021 38.8621 34.3521 39.951 32.5833 40.4845L32.25 40.577V40.85C32.2499 41.3766 32.0566 41.8849 31.7067 42.2784C31.3567 42.6719 30.8745 42.9233 30.3516 42.985L30.1 43H8.6C8.02979 43 7.48292 42.7735 7.07972 42.3703C6.67652 41.9671 6.45 41.4202 6.45 40.85V40.577L6.11675 40.4866C4.41797 39.9743 2.91927 38.949 1.82611 37.5514C0.732944 36.1537 0.0988466 34.4522 0.0107502 32.68L0 32.25V12.9C0 10.6191 0.906069 8.43169 2.51888 6.81888C4.13169 5.20607 6.31914 4.3 8.6 4.3V2.15C8.6 1.57978 8.82652 1.03292 9.22972 0.62972C9.63292 0.226517 10.1798 0 10.75 0H27.95ZM26.23 26.4149C25.8228 26.0158 25.2738 25.7948 24.7037 25.8004C24.1336 25.8061 23.5891 26.0379 23.1899 26.445C22.6894 26.956 22.092 27.3619 21.4326 27.639C20.7733 27.9162 20.0652 28.0589 19.35 28.0589C18.6348 28.0589 17.9267 27.9162 17.2674 27.639C16.608 27.3619 16.0106 26.956 15.5101 26.445C15.1089 26.0473 14.5673 25.8235 14.0024 25.8219C13.4375 25.8204 12.8947 26.0412 12.4913 26.4367C12.088 26.8321 11.8564 27.3705 11.8468 27.9353C11.8372 28.5001 12.0502 29.046 12.4399 29.455C13.3407 30.3742 14.4158 31.1045 15.6024 31.603C16.7889 32.1015 18.063 32.3583 19.35 32.3583C20.637 32.3583 21.9111 32.1015 23.0976 31.603C24.2842 31.1045 25.3593 30.3742 26.2601 29.455C26.6592 29.0478 26.8802 28.4988 26.8746 27.9287C26.8689 27.3586 26.6371 26.8141 26.23 26.4149ZM13.9965 17.2H13.975C13.4048 17.2 12.8579 17.4265 12.4547 17.8297C12.0515 18.2329 11.825 18.7798 11.825 19.35C11.825 19.9202 12.0515 20.4671 12.4547 20.8703C12.8579 21.2735 13.4048 21.5 13.975 21.5H13.9965C14.5667 21.5 15.1136 21.2735 15.5168 20.8703C15.92 20.4671 16.1465 19.9202 16.1465 19.35C16.1465 18.7798 15.92 18.2329 15.5168 17.8297C15.1136 17.4265 14.5667 17.2 13.9965 17.2ZM24.7465 17.2H24.725C24.1548 17.2 23.6079 17.4265 23.2047 17.8297C22.8015 18.2329 22.575 18.7798 22.575 19.35C22.575 19.9202 22.8015 20.4671 23.2047 20.8703C23.6079 21.2735 24.1548 21.5 24.725 21.5H24.7465C25.3167 21.5 25.8636 21.2735 26.2668 20.8703C26.67 20.4671 26.8965 19.9202 26.8965 19.35C26.8965 18.7798 26.67 18.2329 26.2668 17.8297C25.8636 17.4265 25.3167 17.2 24.7465 17.2Z",
    Lizard: "M18.1257 35.4633C17.6035 35.7571 15.8072 37.3712 15.4702 37.8809C15.1147 38.4154 15.0739 39.0738 15.0887 39.6897C15.1406 41.626 14.8147 44.2985 12.8184 43.9728C11.2962 43.7251 12.1517 40.918 12.3739 39.9658C12.6962 38.5712 11.6332 39.0844 11.3517 39.226C10.411 39.6933 7.96288 41.8242 7.07771 39.5234C6.2629 37.3995 9.34805 37.1836 10.1925 36.996C11.0814 36.7977 11.0517 36.0721 10.5221 35.7217C9.51101 35.0562 7.19993 34.1217 8.17029 32.3801C9.00361 30.8864 11.3703 32.3872 11.9739 33.3323C12.2814 33.8137 12.5073 34.5323 12.9925 34.8721C13.4739 35.2084 14.0591 34.95 14.5332 34.7199C14.885 34.55 15.2184 34.3482 15.5554 34.1536C16.1961 33.6332 16.6035 32.8969 16.6035 31.704C16.6035 30.628 15.2961 29.2864 14.7517 28.4298C13.8258 26.9714 14.0591 25.7643 13.6813 25.2227C13.3517 24.7484 12.6443 24.7661 11.9147 24.5644C10.9851 24.3661 10.4703 24.4228 9.69249 25.0245C9.11843 25.4705 8.55547 26.0864 8.1851 26.7094C7.78511 27.3891 7.66659 28.1891 7.24437 28.8652C6.67401 29.7713 5.58513 30.4793 4.49626 29.9943C3.49627 29.5483 3.36664 28.4793 3.98515 27.6652C4.52959 26.9466 5.35921 26.6245 5.80365 25.8033C6.17772 25.113 5.58884 24.8228 4.76662 25.0281C3.87774 25.2475 1 26.1041 1 23.952C1 21.8317 3.61849 22.352 4.7444 22.5361C5.58884 22.6741 5.61847 22.0051 5.34069 21.6618C4.65181 20.8122 2.54072 18.653 3.81108 17.8353C6.23327 16.2778 7.38881 19.9591 7.56289 20.9219C7.79251 22.1856 9.76286 22.352 10.9517 21.729C12.1184 21.0423 12.5851 19.8105 12.1258 18.5184C11.6443 17.191 10.148 15.7504 8.84065 15.4707C5.01847 14.6601 4.56663 11.0389 4.68144 7.66202C4.7444 5.86028 5.66291 2.04088 6.52216 1.48868C8.11844 0.458614 11.2517 1.26568 13.3332 1.99841C16.1776 2.99662 18.6109 4.62491 19.0183 8.39475C19.1813 9.90268 18.1072 11.6265 18.5183 13.1097C18.8961 14.4619 20.0405 16.4902 21.7738 14.9539C22.259 14.3628 23.5368 12.8725 23.6997 12.1044C23.8479 11.4 23.6664 10.1965 23.3738 9.56641C22.8257 8.38413 22.722 5.97355 24.0812 5.8355C26.3627 5.60188 25.4516 9.30446 25.5553 9.84251C25.633 10.2319 26.2256 10.7274 26.8553 10.2991C27.9108 9.58411 28.8219 7.31158 30.1293 8.55404C31.87 10.2036 29.0071 11.5734 28.4404 11.9451C27.6367 12.4725 27.8441 13.2265 28.4886 13.2867C29.3256 13.361 32.2959 13.0991 31.6663 15.315C31.1145 17.2548 29.0404 15.9238 27.9071 15.3397C26.5997 14.6637 25.9479 14.4442 24.6516 15.5203C24.3812 15.7433 23.759 16.8583 23.4886 17.2406C23.1072 17.9521 23.1146 18.6954 23.9071 19.0282C24.596 19.3184 25.3738 19.8388 25.9442 20.3591C27.0219 21.3396 27.5256 22.5042 27.8404 23.2405C28.2552 24.2139 28.8849 24.5608 29.8256 24.529C30.5552 24.4759 31.6256 23.9803 32.2256 23.5201C32.9181 22.9856 33.2589 22.2033 33.4367 21.3927C33.67 20.3343 33.7181 19.9237 33.8663 18.8512C33.9552 18.2105 33.9293 16.4265 35.4292 16.6034C37.3885 16.83 36.2255 19.906 36.0477 20.529C35.9292 20.9361 36.2551 21.2547 36.9292 21.1379C37.5922 21.0246 39.9292 19.0176 40.6921 21.1237C41.3551 22.9644 38.5329 23.1803 37.4922 23.552C36.9292 23.7537 36.6959 24.3626 37.6959 24.7413C38.6699 25.1095 41.4218 26.5218 39.8144 28.0262C38.1366 29.5943 36.0848 26.6033 35.1663 25.7289C34.0478 24.6635 30.7404 27.2121 30.2997 28.3448C29.9182 29.9731 30.7256 31.4067 31.5515 32.904C32.7107 35.0031 33.5107 36.5712 35.5218 37.6756C37.4699 38.7482 38.8477 39.1942 40.9181 38.6066C42.7588 38.0827 43.5143 36.4402 43.2699 34.8332C43.1106 33.7854 42.0218 32.504 40.1107 33.0881C39.1255 33.389 38.1736 34.0013 37.7885 33.5837C37.17 32.9146 39.3181 31.4315 40.9366 31.1164C43.2995 30.6563 45.6995 32.0155 45.9624 34.4544C46.3143 37.7145 44.1514 40.964 41.2551 41.8384C37.1181 43.0879 33.4033 42.2065 30.1219 41.003C28.0589 40.2455 24.7627 38.7092 23.0183 37.5659C22.0405 36.911 19.5665 34.7659 18.1257 35.4633Z M8 12C8.55228 12 9 11.5523 9 11C9 10.4477 8.55228 10 8 10C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12Z M16 8C16.5523 8 17 7.55228 17 7C17 6.44772 16.5523 6 16 6C15.4477 6 15 6.44772 15 7C15 7.55228 15.4477 8 16 8Z",
    Star: "M21.0573 33.8717C21.3756 33.6791 21.7744 33.6791 22.0927 33.8717L33.4971 40.7722C34.2542 41.2302 35.1893 40.5518 34.9888 39.69L31.9606 26.6767C31.8766 26.3158 31.9991 25.938 32.2788 25.695L42.3641 16.9362C43.0315 16.3566 42.6739 15.2597 41.7932 15.1848L28.5199 14.0559C28.1501 14.0244 27.8281 13.7907 27.6836 13.4489L22.4961 1.17864C22.1519 0.36451 20.9981 0.364511 20.6539 1.17864L15.4664 13.4489C15.3219 13.7907 14.9999 14.0244 14.6301 14.0559L1.35681 15.1848C0.476098 15.2597 0.118499 16.3566 0.785854 16.9362L10.8712 25.695C11.1509 25.938 11.2734 26.3158 11.1894 26.6767L8.1612 39.69C7.96066 40.5518 8.89583 41.2302 9.65286 40.7722L21.0573 33.8717Z",
    Watermelon: "M41.3065 29.2979L42.1994 30.1908C43.2463 31.2377 43.2463 32.9313 42.2148 33.9936L40.0902 36.1182C30.9298 45.2939 16.0576 45.2939 6.88185 36.1182C-2.29395 26.9578 -2.29395 12.0856 6.88185 2.90977L9.00645 0.785177C10.0533 -0.261726 11.7469 -0.261726 12.7938 0.785177L13.6867 1.67812L9.5299 5.83494C1.90906 13.4558 1.90906 25.8339 9.5299 33.4547C17.1507 41.0755 29.5288 41.0755 37.1497 33.4547L41.3065 29.2979Z M39.4746 27.4651L35.0714 31.8683C28.4513 38.4884 17.7051 38.4884 11.085 31.8683C4.4649 25.2481 4.4649 14.502 11.085 7.88186L15.4836 3.48486L39.4746 27.4651ZM18.398 13.4859C18.398 13.0408 18.2212 12.614 17.9064 12.2993C17.5917 11.9845 17.1649 11.8077 16.7198 11.8077C16.2748 11.8077 15.8479 11.9845 15.5332 12.2993C15.2185 12.614 15.0417 13.0408 15.0417 13.4859C15.0417 13.9309 15.2185 14.3578 15.5332 14.6725C15.8479 14.9872 16.2748 15.164 16.7198 15.164C17.1649 15.164 17.5917 14.9872 17.9064 14.6725C18.2212 14.3578 18.398 13.9309 18.398 13.4859ZM14.6568 23.7086C15.1019 23.7086 15.5287 23.5318 15.8434 23.2171C16.1581 22.9023 16.3349 22.4755 16.3349 22.0304C16.3349 21.5854 16.1581 21.1585 15.8434 20.8438C15.5287 20.5291 15.1019 20.3523 14.6568 20.3523C14.2117 20.3523 13.7849 20.5291 13.4702 20.8438C13.1555 21.1585 12.9787 21.5854 12.9787 22.0304C12.9787 22.4755 13.1555 22.9023 13.4702 23.2171C13.7849 23.5318 14.2117 23.7086 14.6568 23.7086ZM20.9382 29.99C21.3833 29.99 21.8101 29.8132 22.1248 29.4985C22.4396 29.1838 22.6164 28.7569 22.6164 28.3119C22.6164 27.8668 22.4396 27.44 22.1248 27.1252C21.8101 26.8105 21.3833 26.6337 20.9382 26.6337C20.4932 26.6337 20.0663 26.8105 19.7516 27.1252C19.4369 27.44 19.2601 27.8668 19.2601 28.3119C19.2601 28.7569 19.4369 29.1838 19.7516 29.4985C20.0663 29.8132 20.4932 29.99 20.9382 29.99ZM23.0166 21.4608C23.4617 21.4608 23.8885 21.284 24.2033 20.9693C24.518 20.6546 24.6948 20.2277 24.6948 19.7827C24.6948 19.3376 24.518 18.9108 24.2033 18.5961C23.8885 18.2814 23.4617 18.1046 23.0166 18.1046C22.5716 18.1046 22.1447 18.2814 21.83 18.5961C21.5153 18.9108 21.3385 19.3376 21.3385 19.7827C21.3385 20.2277 21.5153 20.6546 21.83 20.9693C22.1447 21.284 22.5716 21.4608 23.0166 21.4608ZM31.1455 26.2488C31.1455 25.8038 30.9687 25.3769 30.654 25.0622C30.3393 24.7475 29.9125 24.5707 29.4674 24.5707C29.0223 24.5707 28.5955 24.7475 28.2808 25.0622C27.9661 25.3769 27.7893 25.8038 27.7893 26.2488C27.7893 26.6939 27.9661 27.1207 28.2808 27.4355C28.5955 27.7502 29.0223 27.927 29.4674 27.927C29.9125 27.927 30.3393 27.7502 30.654 27.4355C30.9687 27.1207 31.1455 26.6939 31.1455 26.2488Z",
  },
  Colours: {
    Purple: "#6D47FF",
    Blue: "#26C8B9",
    Green: "#99AB47",
    Orange: "#FF611A",
    Yellow: "#F4C900",
    Grey: "#565656"
  },
  IconList: ["Apple", "Bear", "Bolt", "Dog", "Horse", "Icecream", "Lantern", "Lizard", "Star", "Watermelon"],
  ColourList: ["Blue", "Green", "Orange", "Purple", "Yellow"]
}

const Regex = {
  CommaSeperatedValueRegex: "^(?:0|[1-9]\d*)(?:\.(?!.*000)\d+)?$",
  EmailRegExp: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  IntegerRegex: [0 - 9],
  OnlyNUmberRegex: /^[0-9]+$/,
  Paranthesis: /\([^)]*\)/,
  PasswordRegExp: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).+$/,
  PhoneNumberRegExp: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
  PostalCodeRegexp: /[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}/i,
  TextOnlyRegex: /^[A-Za-z\s]*$/,
  UrlRegex: /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi,
  UserNameRegex: /^([a-zA-Z0-9]+\s)*[a-zA-Z0-9]+$/,
}

const RolesForB2B = ["", Roles.Admin, Roles.SeniorLeader, Roles.Teacher]

const RolesEnum = {
  None: 0,
  Teacher: 1 << 0,     // 1
  LeadTeacher: 1 << 1, // 2
  Admin: 1 << 2,       // 4
  MappixAdmin: 1 << 3  // 8  
}

const SessionStorageKeys = {
  Assessment: "assessment",
  AssessmentId: "AssessmentId",
  AssessmentMarks: "assessmentMarks",
  ClassId: "classId",
  ClassName: "className",
  CategoryIndex: "categoryIndex",
  CategoryName: "categoryName",
  CreatePersonaPath: "CreatePersonaPath",
  CurrentDashboard: "CurrentDashboard",
  Email: "Email",
  Error: "Error",
  InviteId: "inviteId",
  IsTeacherDataActive: "isTeacherDataActive",
  IsBackground: "isBackground",
  Location: "Location",
  AccessDenied: "AccessDenied",
  MeetingURL: "MeetingURL",
  Name: "Name",
  NewPasswordEmail: "newPasswordEmail",
  SavePupilAcademicDetails: "savePupilAcademicDetails",
  SessionId: "SessionId",
  SchoolDetailsUpdated: "SchoolDetailsUpdated",
  SessionToken: "SessionToken",
  SocialUser: "SocialUser",
  SubjectId: "subjectId",
  SubjectName: "subjectName",
  TabIndex: "TabIndex",
  UserId: "UserId",
  UserImage: "UserImage",
  UserName: "UserName",
  UserType: "userType",
  Year: "year",
}

const SenStatusOptions = [
  { value: true, label: "SEND" },
  { value: false, label: "Not SEND" },
  { value: true, label: "EHCP" },
];

const SignIn = {
  CantSignIn: "Can't Sign in?",
  CreateAccount: "Create Account",
  Sign_In: "Sign in",
  StaySignedIn: "Stay signed in",
}

const Suffix = ["G", "E", "W"]

const TafCount = {
  Year1: 6,
  Year2: 15,
  Year3: 11,
  Year4: 12,
  Year5: 11,
  Year6: 12,
}

const TeacherRoles = [
  { value: RolesEnum.Admin, label: Roles.Admin },
  { value: RolesEnum.LeadTeacher, label: Roles.LeadTeacher },
  { value: RolesEnum.Teacher, label: Roles.Teacher },
];

const Time = {
  DateFormat_dd_MM_yyyy: "dd/MM/yyyy",
  DateFormat_DD_MM_YYYY: "DD/MM/YYYY",
  DateFormat_YYYY_MM_DD: "YYYY/MM/DD",
  DateFormat_dd_MM_yyyy_hh_mm_a: "dd/MM/yyyy hh:mm a",
  DateFormat_DD_MM_YYYY_hh_mm_a: "DD/MM/YYYY hh:mm a",
  TimeFormat_hh_mm_A: "HH:mm A",
  TimeFormat_hh_mm: "HH:mm",
  TimeFormat_LT: "LT",
  TZ_Formate: "YYYY-MM-DDTHH:mm:ss[Z]",
}

const UserStatus = {
  Active: "Active",
  InActive: "InActive"
}

const WeekDays = {
  Sunday: "Sunday",
  Monday: "Monday",
  Tuesday: "Tuesday",
  Wednesday: "Wednesday",
  Thursday: "Thursday",
  Friday: "Friday",
  Saturday: "Saturday",
}

const WeekDaysEnum = {
  None: 0,
  Sunday: 1 << 6,     // 64
  Monday: 1 << 0,    // 1
  Tuesday: 1 << 1,   // 2
  Wednesday: 1 << 2, // 4
  Thursday: 1 << 3,  // 8
  Friday: 1 << 4,    // 16
  Saturday: 1 << 5,  // 32
}

const pupilProgressReport = {
  pupilId: "",
  firstName: "",
  lastName: "",
  schoolName: "",
  year: 6,
  subjects: [
    {
      subjectName: "Maths",
      Graph: {
        ks1Result: "",
        predictedOutcome: ""
      },
      yearEndPrediction: {},
      currentOutcome: {},
      subjectStrength: {},
      Targets: [
        {
          description: "",
          text: ""
        }
      ],
      rating: {
        icon: "",
        value: "",
        color: "",
      },
      comment: ""
    },
    {
      subjectName: "Reading",
      Graph: {
        ks1Result: "",
        predictedOutcome: ""
      },
      yearEndPrediction: {},
      currentOutcome: {},
      subjectStrength: {},
      Targets: [
        {
          description: "",
          text: ""
        }
      ],
      rating: {
        icon: "",
        value: "",
        color: "",
      },
      comment: ""
    },
    {
      subjectName: "Writing",
      Writing: {
        ks1Result: "",
        predictedOutcome: ""
      },
      yearEndPrediction: {},
      currentOutcome: {},
      subjectStrength: {},
      Targets: [
        {
          description: "",
          text: ""
        }
      ],
      rating: {
        icon: "",
        value: "",
        color: "",
      },
      comment: ""
    },
    {
      subjectName: "Science",
      Graph: {
        ks1Result: "",
        predictedOutcome: ""
      },
      yearEndPrediction: {},
      currentOutcome: {},
      subjectStrength: {},
      Targets: [
        {
          description: "",
          text: ""
        }
      ],
      rating: {
        icon: "",
        value: "",
        color: "",
      },
      comment: ""
    },
    {
      subjectName: "PE",
      Graph: {
        ks1Result: "",
        predictedOutcome: ""
      },
      yearEndPrediction: {},
      currentOutcome: {},
      subjectStrength: {},
      Targets: [
        {
          description: "",
          text: ""
        }
      ],
      rating: {
        icon: "",
        value: "",
        color: "",
      },
      comment: ""
    },
  ]
}

const WondeStatus = {
  none: "none",
  pending: "pending",
  schoolApproved: "schoolApproved",
  accessRevoked: "accessRevoked",
  accessDeclined: "accessDeclined"
}

const YearEnum = {
  None: 0,
  Year1: 1 << 0,    //1
  Year2: 1 << 1,    //2
  Year3: 1 << 2,    //4
  Year4: 1 << 3,    //8
  Year5: 1 << 4,    //16
  Year6: 1 << 5     //32
}

const ObjectivesList = [
  { label: "Year 1", value: YearEnum.Year1 },
  { label: "Year 2", value: YearEnum.Year2 },
  { label: "Year 3", value: YearEnum.Year3 },
  { label: "Year 4", value: YearEnum.Year4 },
  { label: "Year 5", value: YearEnum.Year5 },
  { label: "Year 6", value: YearEnum.Year6 }
];

const YearString = {
  Year1: 1,
  Year2: 2,
  Year3: 3,
  Year4: 4,
  Year5: 5,
  Year6: 6,
}

const AssessmentInfoHeading = (firstName, lastName) => `${Common.MyClasses} ${Common.Divider} ${Common.Subjects} ${Common.Divider} ${Common.AssessmentWriting} ${Common.Divider} ${firstName}${lastName}`

const AssessmentSubtitle = (year) => `${Common.Year} ${year} ${Common.WritingAssessment}`;

const CloseProjectMessage = () => "You\"re about to close this project.";

const ComparisonNames = (str) => {
  let name = "";
  switch (str) {
  case BPComparison.PP: name = `${BigPictureDashBoardPieChartLegend.PupilPremium} Status`; break;
  case BPComparison.SEND: name = BigPictureDashBoardPieChartLegend.Send; break;
  case BPComparison.EAL: name = BigPictureDashBoardPieChartLegend.Eal_; break;
  case BPComparison.GLD: name = "Good Level of Development and Key Stage 1 Outcomes"; break;
  default: name = str; break;
  }
  return name
}

const DeletePupilById = (foreName, surName) => `Do you want to delete the details of ${foreName} ${surName}`;

const DeleteTeacherById = (foreName, surName) => `Do you want to delete the details of User ${foreName} ${surName}`;

const EnableTeacherById = (foreName, surName) => `Do you want to Enable ${foreName} ${surName}`;

const FillColor = (input) => {
  let background = "";
  switch (input) {
  case BigPictureDashBoardPieChartInput.Male: case BigPictureDashBoardPieChartInput.NotPupilPremium: case BigPictureDashBoardPieChartInput.NotEyfs: case BigPictureDashBoardPieChartInput.NotEyfs_: case BigPictureDashBoardPieChartInput.NotSend: case BigPictureDashBoardPieChartInput.NotPP: case BigPictureDashBoardPieChartInput.Fsm: case BigPictureDashBoardPieChartInput.NotEal: background = "var(--male-color)";
    break;
  case BigPictureDashBoardPieChartInput.Female: case BigPictureDashBoardPieChartInput.Lea: case BigPictureDashBoardPieChartInput.Send_: background = "var(--female-color)";
    break;
  case BigPictureDashBoardPieChartInput.Unspecified: case BigPictureDashBoardPieChartInput.PupilPremium: case BigPictureDashBoardPieChartInput.PP: case BigPictureDashBoardPieChartInput.Eyfs: case BigPictureDashBoardPieChartInput.Eyfs_: case BigPictureDashBoardPieChartInput.Send: case BigPictureDashBoardPieChartInput.Fsm6: case BigPictureDashBoardPieChartInput.Eal: background = "var(--unspecified-color)";
    break;
  case BigPictureDashBoardPieChartInput.Ehcp: case BigPictureDashBoardPieChartInput.Ehcp_: background = "var(--ehcp-color)";
    break;
  case BigPictureDashBoardPieChartInput.KsBelow: background = "var(--below-colour)";
    break;
  case BigPictureDashBoardPieChartInput.KsHigh: background = "var(--greater-colour)";
    break;
  case BigPictureDashBoardPieChartInput.KsLow: case BigPictureDashBoardPieChartInput.KsHnm: background = "var(--emerging-colour)";
    break;
  case BigPictureDashBoardPieChartInput.KsUnknown: background = "var(--absent-colour)";
    break;
  case BigPictureDashBoardPieChartInput.KsExs: case BigPictureDashBoardPieChartInput.KsMiddle: background = "var(--expected-colour)";
    break;
  case BigPictureDashBoardPieChartInput.Year1: background = "var(--female-color)";
    break
  case BigPictureDashBoardPieChartInput.Year2: background = "var(--male-color)";
    break;
  case BigPictureDashBoardPieChartInput.Year3: background = "var(--unspecified-color)";
    break;
  case BigPictureDashBoardPieChartInput.Year4: background = "var(--ehcp-color)";
    break;
  case BigPictureDashBoardPieChartInput.Year5: background = "var(--greater-colour)";
    break;
  case BigPictureDashBoardPieChartInput.Year6: background = "var(--expected-colour)";
    break;
  default: background = "var(--white-color)";
    break;
  }
  return background;
}

const mapPupilYearToLabel = (year) => {
  return `${Common.Year} ${year}`;
};

const FilterNames = (selectedFilter) => {
  return (<>
    {selectedFilter?.length > 0 ? (
      selectedFilter?.map((filter, index, array) => (
        <span key={index}>
          {Object.prototype.toString.call(filter) === "[object Array]" ? (
            filter.map((year, yearIndex) => (
              <span key={yearIndex}>{mapPupilYearToLabel(year)}{yearIndex !== filter.length - 1 && ", "}</span>
            ))
          ) : (
            capitalizeFirstLetter(filter)
          )}
          {index !== array.length - 1 && ", "}
          {index === array.length - 1 && " Pupils"}
        </span>
      ))
    ) : (
      <span>{Common.None}</span>
    )}
  </>)
}
const FullName = (firstName, lastName) => `${firstName} ${lastName}`;

const KPISubjectScore = (subjectName) => `KPI ${subjectName} Score`;

const ProfileCreateConfirmationBody = (roleName) => `You don"t have ${roleName} profile enabled. Please create now.`;

const ProfileCreateConfirmationHeader = (roleName) => <p className="name-head">{`Create ${roleName} Profile`}</p>;

const OverallSubjectScore = (subjectName) => `Overall ${subjectName} Score`;

const OverViewHeader = (className, subjectName) => `${className} - ${subjectName} - ${Common.Overview}`;

const RescheduleMeetingMessage = (userName) => `Hi ${userName}, by clicking on open calender you can reschedule the meeting.`;

const RevokeInviteById = (email) => `Do you want to revoke the invitation of ${email}`;

const ScheduleDeleteConfirmationBody = (userName) => `Hi ${userName}, unfortunately this meeting request has been withdrawn.`;

const SubjectIdSelector = (subjectId, highestYear) => {
  switch (subjectId.slice(0, 2)) {
  case Subjects.WritingId:
    subjectId = `${Subjects.WRITE}${highestYear}`;
    break;
  case Subjects.MathId:
    subjectId = `${Subjects.MATH}${highestYear}`;
    break;
  case Subjects.ReadingId:
    subjectId = `${Subjects.READ}${highestYear}`;
    break;
  case Subjects.ScienceId:
    subjectId = `${Subjects.SCI}${highestYear}`;
    break;
  case Subjects.PEId:
    subjectId = `${Subjects.PE}${highestYear}`;
    break;
  default:
    break;
  }
  return subjectId;
}

const SubjectNameSelector = (subjectName, subjectId) => {
  switch (subjectId.slice(0, 2)) {
  case Subjects.WritingId:
    subjectName = Subjects.Writing;
    break;
  case Subjects.MathId:
    subjectName = Subjects.Maths;
    break;
  case Subjects.ReadingId:
    subjectName = Subjects.Reading;
    break;
  case Subjects.ScienceId:
    subjectName = Subjects.Science;
    break;
  case Subjects.PEId:
    subjectName = Subjects.PE;
    break;
  default:
    break;
  }
  return subjectName;
}

const SpecifyName = (input) => {
  let name = "";
  switch (input) {
  case BigPictureDashBoardPieChartInput.Male: name = BigPictureDashBoardPieChartLegend.Male;
    break;
  case BigPictureDashBoardPieChartInput.Female: name = BigPictureDashBoardPieChartLegend.Female;
    break;
  case BigPictureDashBoardPieChartInput.Unspecified: name = BigPictureDashBoardPieChartLegend.Unspecified;
    break;
  case BigPictureDashBoardPieChartInput.PupilPremium: case BigPictureDashBoardPieChartInput.PP: name = BigPictureDashBoardPieChartLegend.PupilPremium
    break;
  case BigPictureDashBoardPieChartInput.NotPupilPremium: case BigPictureDashBoardPieChartInput.NotPP: name = BigPictureDashBoardPieChartLegend.NotPupilPremium;
    break;
  case BigPictureDashBoardPieChartInput.Eyfs: case BigPictureDashBoardPieChartInput.Eyfs_: name = BigPictureDashBoardPieChartLegend.Eyfs
    break;
  case BigPictureDashBoardPieChartInput.NotEyfs: case BigPictureDashBoardPieChartInput.NotEyfs_: name = BigPictureDashBoardPieChartLegend.NotEyfs
    break;
  case BigPictureDashBoardPieChartInput.Send: name = BigPictureDashBoardPieChartLegend.Send
    break;
  case BigPictureDashBoardPieChartInput.NotSend: name = BigPictureDashBoardPieChartLegend.NotSend
    break;
  case BigPictureDashBoardPieChartInput.Ehcp: case BigPictureDashBoardPieChartInput.Ehcp_: name = BigPictureDashBoardPieChartLegend.Ehcp
    break;
  case BigPictureDashBoardPieChartInput.Lea: name = BigPictureDashBoardPieChartLegend.Lea
    break;
  case BigPictureDashBoardPieChartInput.Fsm: name = BigPictureDashBoardPieChartLegend.Fsm
    break;
  case BigPictureDashBoardPieChartInput.Fsm6: name = BigPictureDashBoardPieChartLegend.Fsm6
    break;
  case BigPictureDashBoardPieChartInput.Eal: name = BigPictureDashBoardPieChartLegend.Eal
    break;
  case BigPictureDashBoardPieChartInput.NotEal: name = BigPictureDashBoardPieChartLegend.NotEal
    break;
  case BigPictureDashBoardPieChartInput.KsHigh: name = BigPictureDashBoardPieChartLegend.KsHigh
    break;
  case BigPictureDashBoardPieChartInput.KsMiddle: name = BigPictureDashBoardPieChartLegend.KsMiddle
    break;
  case BigPictureDashBoardPieChartInput.KsLow: name = BigPictureDashBoardPieChartLegend.KsLow
    break;
  case BigPictureDashBoardPieChartInput.KsBelow: name = BigPictureDashBoardPieChartLegend.KsBelow
    break;
  case BigPictureDashBoardPieChartInput.KsUnknown: name = BigPictureDashBoardPieChartLegend.KsUnknown
    break;
  case BigPictureDashBoardPieChartInput.KsExs: name = BigPictureDashBoardPieChartLegend.KsExs
    break;
  case BigPictureDashBoardPieChartInput.KsHnm: name = BigPictureDashBoardPieChartLegend.KsHnm
    break;
  case BigPictureDashBoardPieChartInput.Year1: name = BigPictureDashBoardPieChartLegend.Year1
    break;
  case BigPictureDashBoardPieChartInput.Year2: name = BigPictureDashBoardPieChartLegend.Year2
    break;
  case BigPictureDashBoardPieChartInput.Year3: name = BigPictureDashBoardPieChartLegend.Year3
    break;
  case BigPictureDashBoardPieChartInput.Year4: name = BigPictureDashBoardPieChartLegend.Year4
    break;
  case BigPictureDashBoardPieChartInput.Year5: name = BigPictureDashBoardPieChartLegend.Year5
    break;
  case BigPictureDashBoardPieChartInput.Year6: name = BigPictureDashBoardPieChartLegend.Year6
    break;
  case BigPictureDashBoardPieChartInput.Send_: name = BigPictureDashBoardPieChartLegend.Send_
    break;
  default: name = input
    break;
  }
  return name;
}

const SpecifyPieChartName = (str) => {
  let name = "";
  switch (str) {
  case BigPictureDashBoardPieChartInput.AllPupil: name = BigPictureDashBoardPieChartLegend.AllPupil;
    break;
  case BigPictureDashBoardPieChartInput.AllPupilPre: name = BigPictureDashBoardPieChartLegend.AllPupilPre;
    break;
  case BigPictureDashBoardPieChartInput.PupilPremium: name = BigPictureDashBoardPieChartLegend.PupilPremium;
    break;
  case BigPictureDashBoardPieChartInput.Gender: name = BigPictureDashBoardPieChartLegend.Gender;
    break;
  case BigPictureDashBoardPieChartInput.Eal_: case BigPictureDashBoardPieChartInput.Eal: name = BigPictureDashBoardPieChartLegend.Eal_;
    break;
  case BigPictureDashBoardPieChartInput.Gld: name = BigPictureDashBoardPieChartLegend.Gld;
    break;
  case BigPictureDashBoardPieChartInput.Ks1Maths: name = BigPictureDashBoardPieChartLegend.Ks1Maths;
    break;
  case BigPictureDashBoardPieChartInput.Ks1Reading: name = BigPictureDashBoardPieChartLegend.Ks1Reading;
    break;
  case BigPictureDashBoardPieChartInput.Ks1Science: name = BigPictureDashBoardPieChartLegend.Ks1Science;
    break;
  case BigPictureDashBoardPieChartInput.Ks1Writing: name = BigPictureDashBoardPieChartLegend.Ks1Writing;
    break;
  case BigPictureDashBoardPieChartInput.SendStatus: name = BigPictureDashBoardPieChartLegend.SendStatus;
    break;
  case BigPictureDashBoardPieChartInput.PpStatus: case BigPictureDashBoardPieChartInput.Pp: name = BigPictureDashBoardPieChartLegend.PpStatus;
    break;
  case BigPictureDashBoardPieChartInput.FreeSchoolMeals: name = BigPictureDashBoardPieChartLegend.FreeSchoolMeals;
    break;
  case BigPictureDashBoardPieChartInput.FreeSchoolMeals6: name = BigPictureDashBoardPieChartLegend.FreeSchoolMeals6;
    break;
  case BigPictureDashBoardPieChartInput.Lea: name = BigPictureDashBoardPieChartLegend.Lea;
    break;
  case BigPictureDashBoardPieChartInput.NotPupilPremium: name = BigPictureDashBoardPieChartLegend.NotPupilPremium;
    break;
  case BigPictureDashBoardPieChartInput.Male: name = BigPictureDashBoardPieChartLegend.Male;
    break;
  case BigPictureDashBoardPieChartInput.Female: name = BigPictureDashBoardPieChartLegend.Female;
    break;
  case BigPictureDashBoardPieChartInput.Unspecified: case BigPictureDashBoardPieChartInput.Notspecified: name = BigPictureDashBoardPieChartLegend.Unspecified;
    break;
  case BigPictureDashBoardPieChartInput.Year1: name = BigPictureDashBoardPieChartLegend.Year1
    break;
  case BigPictureDashBoardPieChartInput.Year2: name = BigPictureDashBoardPieChartLegend.Year2
    break;
  case BigPictureDashBoardPieChartInput.Year3: name = BigPictureDashBoardPieChartLegend.Year3
    break;
  case BigPictureDashBoardPieChartInput.Year4: name = BigPictureDashBoardPieChartLegend.Year4
    break;
  case BigPictureDashBoardPieChartInput.Year5: name = BigPictureDashBoardPieChartLegend.Year5
    break;
  case BigPictureDashBoardPieChartInput.Year6: name = BigPictureDashBoardPieChartLegend.Year6
    break;
  case BigPictureDashBoardPieChartInput.Send_: name = BigPictureDashBoardPieChartLegend.Send_
    break;
  case BigPictureDashBoardPieChartInput.NotEal: name = BigPictureDashBoardPieChartLegend.NotEal
    break;
  case BigPictureDashBoardPieChartInput.Send: name = BigPictureDashBoardPieChartLegend.Send
    break;
  case BigPictureDashBoardPieChartInput.Ehcp: name = BigPictureDashBoardPieChartLegend.Ehcp
    break;
  case BigPictureDashBoardPieChartInput.AllSend: case BigPictureDashBoardPieChartInput.AllSend_: name = BigPictureDashBoardPieChartLegend.AllSend
    break;
  case BigPictureDashBoardPieChartInput.NotSend: name = BigPictureDashBoardPieChartLegend.NotSend
    break;
  case BigPictureDashBoardPieChartInput.AllKs1MathsPupil: name = BigPictureDashBoardPieChartLegend.AllKs1MathsPupil
    break;
  case BigPictureDashBoardPieChartInput.AllKs1ReadingPupil: name = BigPictureDashBoardPieChartLegend.AllKs1ReadingPupil
    break;
  case BigPictureDashBoardPieChartInput.AllKs1SciencePupil: name = BigPictureDashBoardPieChartLegend.AllKs1SciencePupil
    break;
  case BigPictureDashBoardPieChartInput.AllKs1WritingPupil: name = BigPictureDashBoardPieChartLegend.AllKs1WritingPupil
    break;
  case BigPictureDashBoardPieChartInput.NotGld: name = BigPictureDashBoardPieChartLegend.NotGld
    break;
  case BigPictureDashBoardPieChartInput.MathsKs1Below: name = BigPictureDashBoardPieChartLegend.MathsKs1Below
    break;
  case BigPictureDashBoardPieChartInput.MathsKs1High: name = BigPictureDashBoardPieChartLegend.MathsKs1High
    break;
  case BigPictureDashBoardPieChartInput.MathsKs1Low: name = BigPictureDashBoardPieChartLegend.MathsKs1Low
    break;
  case BigPictureDashBoardPieChartInput.MathsKs1Middle: name = BigPictureDashBoardPieChartLegend.MathsKs1Middle
    break;
  case BigPictureDashBoardPieChartInput.MathsKs1Unknown: name = BigPictureDashBoardPieChartLegend.MathsKs1Unknown
    break;
  case BigPictureDashBoardPieChartInput.ReadingKs1Below: name = BigPictureDashBoardPieChartLegend.ReadingKs1Below
    break;
  case BigPictureDashBoardPieChartInput.ReadingKs1High: name = BigPictureDashBoardPieChartLegend.ReadingKs1High
    break;
  case BigPictureDashBoardPieChartInput.ReadingKs1Low: name = BigPictureDashBoardPieChartLegend.ReadingKs1Low
    break;
  case BigPictureDashBoardPieChartInput.ReadingKs1Middle: name = BigPictureDashBoardPieChartLegend.ReadingKs1Middle
    break;
  case BigPictureDashBoardPieChartInput.ReadingKs1Unknown: name = BigPictureDashBoardPieChartLegend.ReadingKs1Unknown
    break;
  case BigPictureDashBoardPieChartInput.WritingKs1Below: name = BigPictureDashBoardPieChartLegend.WritingKs1Below
    break;
  case BigPictureDashBoardPieChartInput.WritingKs1High: name = BigPictureDashBoardPieChartLegend.WritingKs1High
    break;
  case BigPictureDashBoardPieChartInput.WritingKs1Low: name = BigPictureDashBoardPieChartLegend.WritingKs1Low
    break;
  case BigPictureDashBoardPieChartInput.WritingKs1Middle: name = BigPictureDashBoardPieChartLegend.WritingKs1Middle
    break;
  case BigPictureDashBoardPieChartInput.WritingKs1Unknown: name = BigPictureDashBoardPieChartLegend.WritingKs1Unknown
    break;
  case BigPictureDashBoardPieChartInput.ScienceKs1Below: name = BigPictureDashBoardPieChartLegend.ScienceKs1Below
    break;
  case BigPictureDashBoardPieChartInput.ScienceKs1High: name = BigPictureDashBoardPieChartLegend.ScienceKs1High
    break;
  case BigPictureDashBoardPieChartInput.ScienceKs1Low: name = BigPictureDashBoardPieChartLegend.ScienceKs1Low
    break;
  case BigPictureDashBoardPieChartInput.ScienceKs1Middle: name = BigPictureDashBoardPieChartLegend.ScienceKs1Middle
    break;
  case BigPictureDashBoardPieChartInput.ScienceKs1Unknown: name = BigPictureDashBoardPieChartLegend.ScienceKs1Unknown
    break;
  default: name = str;
    break;
  }
  return name;
}



export {
  Accessors, Activity, Array, AssessmentDisabledTexts, BigPicture, BigPictureDashBoardPieChartLegend, BigPictureDashBoardPieChartInput, BPComparison, Common, Colors, CurriculumCoverageAccordion, DataType, DefaultData, EditProfileConstants, ExternalLinks, Gender, KSResults, KSResultsCommonOptions, KSResultsScienceOptions, KSResultsScience, LocalStorageKeys, LandingPage, MappixLevels, Marking, MarkingColors, MarkingOutcome, MarkingLevels, NavigationBar, ObjectivesList,
  previousYearOutcome, previousYearOutcomeSubjects, Ratings, Regex, Roles, RolesEnum, RolesForB2B, SessionStorageKeys, SenStatusOptions, SignIn, Subjects, Suffix, TafCount, TeacherRoles, Time, UserStatus, WeekDays, WeekDaysEnum, WondeStatus, YearEnum, YearString, PupilProgressOptions, AssessmentInfoHeading, AssessmentSubtitle, CloseProjectMessage, ComparisonNames, DeletePupilById, DeleteTeacherById, EnableTeacherById, FillColor, FilterNames, FullName, KPISubjectScore, ProfileCreateConfirmationBody, ProfileCreateConfirmationHeader, OverallSubjectScore, OverViewHeader, RescheduleMeetingMessage, RevokeInviteById, ScheduleDeleteConfirmationBody, SpecifyName, SpecifyPieChartName, SubjectIdSelector, SubjectNameSelector, pupilProgressReport
};
